{
  "schemaVersion": "cogo.action-consumer-catalog.v1",
  "catalogDigest": "sha256:60f494484133f3634fba3ac05d697887819e18d26b9971078e609ae9e62a3b5b",
  "source": "@cogo/runtime-v2",
  "actions": [
    {
      "action": "addTableRow",
      "runtimeAliases": [],
      "reads": [
        {
          "channelId": "parameter-channel:addTableRow:position",
          "path": "position",
          "required": false,
          "role": "selector"
        },
        {
          "channelId": "parameter-channel:addTableRow:row",
          "path": "row",
          "required": false,
          "role": "payload"
        },
        {
          "channelId": "parameter-channel:addTableRow:target",
          "path": "target",
          "required": true,
          "role": "target"
        }
      ],
      "resultChannels": [
        {
          "channelId": "result-channel:addTableRow:sha256:5e680edc286f76bc1908e751533aa390759ed7860011a389f683935f75cfda7b",
          "kind": "state-target",
          "targetParam": "target"
        }
      ],
      "hostCapabilities": [],
      "requiredHostCapabilities": [],
      "missingConsumerPolicy": "reject-before-side-effects"
    },
    {
      "action": "aiCancel",
      "runtimeAliases": [],
      "reads": [
        {
          "channelId": "parameter-channel:aiCancel:streamId",
          "path": "streamId",
          "required": true,
          "role": "selector"
        }
      ],
      "resultChannels": [
        {
          "channelId": "result-channel:aiCancel:sha256:00a686c87a99a2087cb7463476e17845ddb993eb883d83be362ef469943c0b72",
          "kind": "host-effect",
          "capabilityId": "host.ai-stream",
          "operation": "cancel"
        }
      ],
      "hostCapabilities": [
        {
          "channelId": "host-channel:aiCancel:sha256:ed403dea488c32d33729c4abad6c4d67ada083d4fa24134802b32ed705906d62",
          "capabilityId": "host.ai-stream",
          "operation": "cancel"
        }
      ],
      "requiredHostCapabilities": [
        "host.ai-stream"
      ],
      "missingConsumerPolicy": "block-host"
    },
    {
      "action": "analyticsEvent",
      "runtimeAliases": [],
      "reads": [
        {
          "channelId": "parameter-channel:analyticsEvent:data",
          "path": "data",
          "required": false,
          "role": "payload"
        },
        {
          "channelId": "parameter-channel:analyticsEvent:event",
          "path": "event",
          "required": true,
          "role": "selector"
        }
      ],
      "resultChannels": [
        {
          "channelId": "result-channel:analyticsEvent:sha256:3854970aed2866a46eb16548e2264ffa48bd12f6ae09922f9297c860401cf698",
          "kind": "host-effect",
          "capabilityId": "host.analytics",
          "operation": "dispatch"
        }
      ],
      "hostCapabilities": [
        {
          "channelId": "host-channel:analyticsEvent:sha256:21cab33b4314dc83e3c4f80fe276b623f81440f1293c6bb5aee87ff7cad9086a",
          "capabilityId": "host.analytics",
          "operation": "dispatch"
        }
      ],
      "requiredHostCapabilities": [
        "host.analytics"
      ],
      "missingConsumerPolicy": "block-host"
    },
    {
      "action": "applyReportDesignTheme",
      "runtimeAliases": [],
      "reads": [
        {
          "channelId": "parameter-channel:applyReportDesignTheme:accent",
          "path": "accent",
          "required": false,
          "role": "input"
        },
        {
          "channelId": "parameter-channel:applyReportDesignTheme:surface",
          "path": "surface",
          "required": false,
          "role": "input"
        },
        {
          "channelId": "parameter-channel:applyReportDesignTheme:target",
          "path": "target",
          "required": false,
          "role": "target"
        },
        {
          "channelId": "parameter-channel:applyReportDesignTheme:themeId",
          "path": "themeId",
          "required": true,
          "role": "input"
        },
        {
          "channelId": "parameter-channel:applyReportDesignTheme:tokenPatch",
          "path": "tokenPatch",
          "required": false,
          "role": "payload"
        }
      ],
      "resultChannels": [
        {
          "channelId": "result-channel:applyReportDesignTheme:sha256:b051a0c79a74232dcb566ebaab864992a6315b96c20f6e46b07e7443df0d985c",
          "kind": "return-capture",
          "capture": "step-name",
          "envelope": {
            "kind": "object",
            "properties": {
              "accent": {
                "kind": "scalar",
                "type": "string"
              },
              "appliedBy": {
                "kind": "scalar",
                "type": "string"
              },
              "surface": {
                "kind": "scalar",
                "type": "string"
              },
              "themeId": {
                "kind": "scalar",
                "type": "string"
              },
              "tokenPatch": {
                "kind": "unknown"
              }
            },
            "required": [
              "accent",
              "appliedBy",
              "surface",
              "themeId",
              "tokenPatch"
            ]
          }
        },
        {
          "channelId": "result-channel:applyReportDesignTheme:sha256:04cd75e5f9a5ec74ebb94b05024bbf2a7ee36e557e76a819a4f9c5652d8a0cda",
          "kind": "state-target",
          "defaultTarget": "local.reportDesignStatus",
          "envelope": {
            "kind": "scalar",
            "type": "string"
          }
        },
        {
          "channelId": "result-channel:applyReportDesignTheme:sha256:07a404a0b19bcf27cef33893e57495033d903bc9ec772addec22884e670e525a",
          "kind": "state-target",
          "defaultTarget": "local.reportDesignPanelOpen",
          "envelope": {
            "kind": "scalar",
            "type": "boolean"
          }
        },
        {
          "channelId": "result-channel:applyReportDesignTheme:sha256:143b840d855807f3f5521244f6c1fae683793cc9e39d100dcbac117049948005",
          "kind": "state-target",
          "defaultTarget": "local.previewDesignAppliedAt",
          "envelope": {
            "kind": "scalar",
            "type": "string"
          }
        },
        {
          "channelId": "result-channel:applyReportDesignTheme:sha256:2a8f9a8bcd223d7ff2672c8e0c47b8d98282770c4dbc8606ed64e9aba9ae083b",
          "kind": "state-target",
          "targetParam": "target",
          "defaultTarget": "local.reportDesignTheme",
          "envelope": {
            "kind": "object",
            "properties": {
              "accent": {
                "kind": "scalar",
                "type": "string"
              },
              "appliedBy": {
                "kind": "scalar",
                "type": "string"
              },
              "surface": {
                "kind": "scalar",
                "type": "string"
              },
              "themeId": {
                "kind": "scalar",
                "type": "string"
              },
              "tokenPatch": {
                "kind": "unknown"
              }
            },
            "required": [
              "accent",
              "appliedBy",
              "surface",
              "themeId",
              "tokenPatch"
            ]
          }
        },
        {
          "channelId": "result-channel:applyReportDesignTheme:sha256:3bcaa8633e119d625863c02ede85a7c07e498f53e1442c6350100ddb8cccf4a6",
          "kind": "state-target",
          "defaultTarget": "local.reportDesignAccent",
          "envelope": {
            "kind": "scalar",
            "type": "string"
          }
        },
        {
          "channelId": "result-channel:applyReportDesignTheme:sha256:4fbce59d078eec96a113f525d1ec4146980326cde172125d8b759ffede9ed9ec",
          "kind": "state-target",
          "defaultTarget": "local.reportDesignThemeId",
          "envelope": {
            "kind": "scalar",
            "type": "string"
          }
        }
      ],
      "hostCapabilities": [],
      "requiredHostCapabilities": [],
      "missingConsumerPolicy": "reject-before-side-effects"
    },
    {
      "action": "batchAction",
      "runtimeAliases": [],
      "reads": [
        {
          "channelId": "parameter-channel:batchAction:actions",
          "path": "actions",
          "required": true,
          "role": "payload"
        },
        {
          "channelId": "parameter-channel:batchAction:stopOnError",
          "path": "stopOnError",
          "required": false,
          "role": "guard"
        }
      ],
      "resultChannels": [],
      "hostCapabilities": [],
      "requiredHostCapabilities": [],
      "missingConsumerPolicy": "reject-before-side-effects"
    },
    {
      "action": "callFlow",
      "runtimeAliases": [],
      "reads": [
        {
          "channelId": "parameter-channel:callFlow:await",
          "path": "await",
          "required": false,
          "role": "guard"
        },
        {
          "channelId": "parameter-channel:callFlow:context",
          "path": "context",
          "required": false,
          "role": "payload"
        },
        {
          "aliases": [
            "flowName"
          ],
          "channelId": "parameter-channel:callFlow:flow",
          "path": "flow",
          "required": true,
          "role": "selector"
        }
      ],
      "resultChannels": [
        {
          "channelId": "result-channel:callFlow:sha256:d5bc11f269f285b768f29210068f9dd1d5b5558daa0315388a1e92bf66d5309e",
          "kind": "host-registry",
          "capabilityId": "host.flow-registry",
          "selectorParam": "flow",
          "payloadParam": "context"
        }
      ],
      "hostCapabilities": [
        {
          "channelId": "host-channel:callFlow:sha256:2a57e685537b9cb5e043dbe6b86202bd9ddb33425b25f9c1045b9f3c993c2c35",
          "capabilityId": "host.flow-registry",
          "operation": "invoke"
        }
      ],
      "requiredHostCapabilities": [
        "host.flow-registry"
      ],
      "missingConsumerPolicy": "block-host"
    },
    {
      "action": "cfAiGateway",
      "runtimeAliases": [],
      "reads": [
        {
          "channelId": "parameter-channel:cfAiGateway:action",
          "path": "action",
          "required": true,
          "role": "selector"
        },
        {
          "channelId": "parameter-channel:cfAiGateway:logData",
          "path": "logData",
          "required": false,
          "role": "payload"
        },
        {
          "channelId": "parameter-channel:cfAiGateway:model",
          "path": "model",
          "required": false,
          "role": "input"
        },
        {
          "channelId": "parameter-channel:cfAiGateway:prompt",
          "path": "prompt",
          "required": false,
          "role": "input"
        },
        {
          "channelId": "parameter-channel:cfAiGateway:provider",
          "path": "provider",
          "required": false,
          "role": "input"
        },
        {
          "channelId": "parameter-channel:cfAiGateway:resultTarget",
          "path": "resultTarget",
          "required": false,
          "role": "target"
        }
      ],
      "resultChannels": [
        {
          "channelId": "result-channel:cfAiGateway:sha256:09dcbd3f87a01b5f322c850668b541d6e702f78e7ebcf4d375c7c354d696498d",
          "kind": "state-target",
          "targetParam": "resultTarget",
          "defaultTarget": "_results.cfAiGateway"
        }
      ],
      "hostCapabilities": [],
      "requiredHostCapabilities": [
        "host.cloudflare"
      ],
      "missingConsumerPolicy": "block-host"
    },
    {
      "action": "cfDurableObject",
      "runtimeAliases": [],
      "reads": [
        {
          "channelId": "parameter-channel:cfDurableObject:action",
          "path": "action",
          "required": true,
          "role": "selector"
        },
        {
          "channelId": "parameter-channel:cfDurableObject:alarmAt",
          "path": "alarmAt",
          "required": false,
          "role": "input"
        },
        {
          "channelId": "parameter-channel:cfDurableObject:data",
          "path": "data",
          "required": false,
          "role": "payload"
        },
        {
          "channelId": "parameter-channel:cfDurableObject:objectId",
          "path": "objectId",
          "required": false,
          "role": "input"
        },
        {
          "channelId": "parameter-channel:cfDurableObject:resultTarget",
          "path": "resultTarget",
          "required": false,
          "role": "target"
        }
      ],
      "resultChannels": [
        {
          "channelId": "result-channel:cfDurableObject:sha256:4ec3e19a34649d30a7dddffc145019cbab68e4c22ce6f77179e4f8fb2a2fed92",
          "kind": "state-target",
          "targetParam": "resultTarget",
          "defaultTarget": "_results.cfDurableObject"
        }
      ],
      "hostCapabilities": [],
      "requiredHostCapabilities": [
        "host.cloudflare"
      ],
      "missingConsumerPolicy": "block-host"
    },
    {
      "action": "cfKv",
      "runtimeAliases": [],
      "reads": [
        {
          "channelId": "parameter-channel:cfKv:action",
          "path": "action",
          "required": true,
          "role": "selector"
        },
        {
          "channelId": "parameter-channel:cfKv:key",
          "path": "key",
          "required": false,
          "role": "input"
        },
        {
          "channelId": "parameter-channel:cfKv:prefix",
          "path": "prefix",
          "required": false,
          "role": "input"
        },
        {
          "channelId": "parameter-channel:cfKv:resultTarget",
          "path": "resultTarget",
          "required": false,
          "role": "target"
        },
        {
          "channelId": "parameter-channel:cfKv:ttl",
          "path": "ttl",
          "required": false,
          "role": "input"
        },
        {
          "channelId": "parameter-channel:cfKv:value",
          "path": "value",
          "required": false,
          "role": "payload"
        }
      ],
      "resultChannels": [
        {
          "channelId": "result-channel:cfKv:sha256:2f909835aaa87743231ea0626253126f790a4c1dbb925db30a5e499bbbdf606d",
          "kind": "state-target",
          "targetParam": "resultTarget",
          "defaultTarget": "_results.cfKv"
        }
      ],
      "hostCapabilities": [],
      "requiredHostCapabilities": [
        "host.cloudflare"
      ],
      "missingConsumerPolicy": "block-host"
    },
    {
      "action": "cfR2",
      "runtimeAliases": [],
      "reads": [
        {
          "channelId": "parameter-channel:cfR2:action",
          "path": "action",
          "required": true,
          "role": "selector"
        },
        {
          "channelId": "parameter-channel:cfR2:appId",
          "path": "appId",
          "required": false,
          "role": "input"
        },
        {
          "channelId": "parameter-channel:cfR2:contentType",
          "path": "contentType",
          "required": false,
          "role": "input"
        },
        {
          "channelId": "parameter-channel:cfR2:file",
          "path": "file",
          "required": false,
          "role": "payload"
        },
        {
          "channelId": "parameter-channel:cfR2:path",
          "path": "path",
          "required": false,
          "role": "input"
        },
        {
          "channelId": "parameter-channel:cfR2:prefix",
          "path": "prefix",
          "required": false,
          "role": "input"
        },
        {
          "channelId": "parameter-channel:cfR2:resultTarget",
          "path": "resultTarget",
          "required": false,
          "role": "target"
        }
      ],
      "resultChannels": [
        {
          "channelId": "result-channel:cfR2:sha256:fc62b8794e0f141b68138b7ceba8114b86f8ee4c22f167de4554e3b30a41e0a3",
          "kind": "state-target",
          "targetParam": "resultTarget",
          "defaultTarget": "_results.cfR2"
        }
      ],
      "hostCapabilities": [],
      "requiredHostCapabilities": [
        "host.cloudflare"
      ],
      "missingConsumerPolicy": "block-host"
    },
    {
      "action": "clipboardRead",
      "runtimeAliases": [],
      "reads": [
        {
          "channelId": "parameter-channel:clipboardRead:resultPath",
          "path": "resultPath",
          "required": false,
          "role": "target"
        }
      ],
      "resultChannels": [
        {
          "channelId": "result-channel:clipboardRead:sha256:9919f3dbd626847862f4265b195dcbd60775377c59382a9fcb4563e381fe7528",
          "kind": "host-effect",
          "capabilityId": "host.clipboard",
          "operation": "read"
        },
        {
          "channelId": "result-channel:clipboardRead:sha256:b5ffc09631635530942e64e742d0503f5f858b8d01a090eb0469df0bea43a09e",
          "kind": "state-target",
          "targetParam": "resultPath",
          "defaultTarget": "_results.clipboard"
        }
      ],
      "hostCapabilities": [
        {
          "channelId": "host-channel:clipboardRead:sha256:d83b36d4f34bd19d867db1032ea1b5a6e60c136b442551a8c05d82515bf15a54",
          "capabilityId": "host.clipboard",
          "operation": "read"
        }
      ],
      "requiredHostCapabilities": [
        "host.clipboard"
      ],
      "missingConsumerPolicy": "block-host"
    },
    {
      "action": "cogo.formula.dependencies",
      "runtimeAliases": [],
      "reads": [
        {
          "channelId": "parameter-channel:cogo.formula.dependencies:allowReturnArray",
          "path": "allowReturnArray",
          "required": false,
          "role": "guard"
        },
        {
          "channelId": "parameter-channel:cogo.formula.dependencies:cells",
          "path": "cells",
          "required": false,
          "role": "payload"
        },
        {
          "aliases": [
            "expression"
          ],
          "channelId": "parameter-channel:cogo.formula.dependencies:formula",
          "path": "formula",
          "required": true,
          "role": "input"
        },
        {
          "channelId": "parameter-channel:cogo.formula.dependencies:functions",
          "path": "functions",
          "required": false,
          "role": "payload"
        },
        {
          "channelId": "parameter-channel:cogo.formula.dependencies:namedRefs",
          "path": "namedRefs",
          "required": false,
          "role": "payload"
        },
        {
          "channelId": "parameter-channel:cogo.formula.dependencies:position",
          "path": "position",
          "required": false,
          "role": "input"
        },
        {
          "channelId": "parameter-channel:cogo.formula.dependencies:sheets",
          "path": "sheets",
          "required": false,
          "role": "payload"
        }
      ],
      "resultChannels": [
        {
          "channelId": "result-channel:cogo.formula.dependencies:sha256:1182f31e9f03c5704bab18950e9381188a2a4411c1380c47c4fce875f9383d02",
          "kind": "return-capture",
          "capture": "step-name"
        }
      ],
      "hostCapabilities": [],
      "requiredHostCapabilities": [],
      "missingConsumerPolicy": "reject-before-side-effects"
    },
    {
      "action": "cogo.formula.evaluate",
      "runtimeAliases": [],
      "reads": [
        {
          "channelId": "parameter-channel:cogo.formula.evaluate:allowReturnArray",
          "path": "allowReturnArray",
          "required": false,
          "role": "guard"
        },
        {
          "channelId": "parameter-channel:cogo.formula.evaluate:cells",
          "path": "cells",
          "required": false,
          "role": "payload"
        },
        {
          "aliases": [
            "expression"
          ],
          "channelId": "parameter-channel:cogo.formula.evaluate:formula",
          "path": "formula",
          "required": true,
          "role": "input"
        },
        {
          "channelId": "parameter-channel:cogo.formula.evaluate:functions",
          "path": "functions",
          "required": false,
          "role": "payload"
        },
        {
          "channelId": "parameter-channel:cogo.formula.evaluate:namedRefs",
          "path": "namedRefs",
          "required": false,
          "role": "payload"
        },
        {
          "channelId": "parameter-channel:cogo.formula.evaluate:position",
          "path": "position",
          "required": false,
          "role": "input"
        },
        {
          "channelId": "parameter-channel:cogo.formula.evaluate:sheets",
          "path": "sheets",
          "required": false,
          "role": "payload"
        }
      ],
      "resultChannels": [
        {
          "channelId": "result-channel:cogo.formula.evaluate:sha256:1182f31e9f03c5704bab18950e9381188a2a4411c1380c47c4fce875f9383d02",
          "kind": "return-capture",
          "capture": "step-name"
        }
      ],
      "hostCapabilities": [],
      "requiredHostCapabilities": [],
      "missingConsumerPolicy": "reject-before-side-effects"
    },
    {
      "action": "compute",
      "runtimeAliases": [],
      "reads": [
        {
          "channelId": "parameter-channel:compute:expression",
          "path": "expression",
          "required": false,
          "role": "input"
        },
        {
          "channelId": "parameter-channel:compute:target",
          "path": "target",
          "required": true,
          "role": "target"
        },
        {
          "channelId": "parameter-channel:compute:value",
          "path": "value",
          "required": false,
          "role": "payload"
        }
      ],
      "resultChannels": [
        {
          "channelId": "result-channel:compute:sha256:1182f31e9f03c5704bab18950e9381188a2a4411c1380c47c4fce875f9383d02",
          "kind": "return-capture",
          "capture": "step-name"
        },
        {
          "channelId": "result-channel:compute:sha256:5e680edc286f76bc1908e751533aa390759ed7860011a389f683935f75cfda7b",
          "kind": "state-target",
          "targetParam": "target"
        }
      ],
      "hostCapabilities": [],
      "requiredHostCapabilities": [],
      "missingConsumerPolicy": "reject-before-side-effects"
    },
    {
      "action": "computeDateRange",
      "runtimeAliases": [],
      "reads": [
        {
          "channelId": "parameter-channel:computeDateRange:range",
          "path": "range",
          "required": false,
          "role": "selector"
        },
        {
          "channelId": "parameter-channel:computeDateRange:statePrefix",
          "path": "statePrefix",
          "required": false,
          "role": "target"
        }
      ],
      "resultChannels": [
        {
          "channelId": "result-channel:computeDateRange:sha256:e081ab32fc3b1df54c1765dcc8dc3d0e7c9a5a36303fb0a106bb010aa9905d41",
          "kind": "state-target",
          "targetParam": "statePrefix",
          "defaultTarget": "ui",
          "targetSuffixes": [
            "dateFrom",
            "dateFromCompact",
            "dateRange",
            "dateTo",
            "dateToCompact",
            "pageIndex"
          ]
        }
      ],
      "hostCapabilities": [],
      "requiredHostCapabilities": [],
      "missingConsumerPolicy": "reject-before-side-effects"
    },
    {
      "action": "computeField",
      "runtimeAliases": [],
      "reads": [
        {
          "channelId": "parameter-channel:computeField:expression",
          "path": "expression",
          "required": true,
          "role": "input"
        },
        {
          "channelId": "parameter-channel:computeField:field",
          "path": "field",
          "required": true,
          "role": "selector"
        },
        {
          "channelId": "parameter-channel:computeField:source",
          "path": "source",
          "required": true,
          "role": "input"
        },
        {
          "channelId": "parameter-channel:computeField:target",
          "path": "target",
          "required": false,
          "role": "target"
        }
      ],
      "resultChannels": [
        {
          "channelId": "result-channel:computeField:sha256:5e680edc286f76bc1908e751533aa390759ed7860011a389f683935f75cfda7b",
          "kind": "state-target",
          "targetParam": "target"
        }
      ],
      "hostCapabilities": [],
      "requiredHostCapabilities": [],
      "missingConsumerPolicy": "reject-before-side-effects"
    },
    {
      "action": "conditionalDelay",
      "runtimeAliases": [],
      "reads": [
        {
          "channelId": "parameter-channel:conditionalDelay:condition",
          "path": "condition",
          "required": true,
          "role": "guard"
        },
        {
          "aliases": [
            "ms"
          ],
          "channelId": "parameter-channel:conditionalDelay:duration",
          "path": "duration",
          "required": false,
          "role": "input"
        },
        {
          "channelId": "parameter-channel:conditionalDelay:maxWait",
          "path": "maxWait",
          "required": false,
          "role": "input"
        },
        {
          "channelId": "parameter-channel:conditionalDelay:pollInterval",
          "path": "pollInterval",
          "required": false,
          "role": "input"
        }
      ],
      "resultChannels": [],
      "hostCapabilities": [],
      "requiredHostCapabilities": [],
      "missingConsumerPolicy": "reject-before-side-effects"
    },
    {
      "action": "confirmAction",
      "runtimeAliases": [],
      "reads": [
        {
          "channelId": "parameter-channel:confirmAction:cancelLabel",
          "path": "cancelLabel",
          "required": false,
          "role": "input"
        },
        {
          "channelId": "parameter-channel:confirmAction:confirmLabel",
          "path": "confirmLabel",
          "required": false,
          "role": "input"
        },
        {
          "channelId": "parameter-channel:confirmAction:dangerous",
          "path": "dangerous",
          "required": false,
          "role": "guard"
        },
        {
          "channelId": "parameter-channel:confirmAction:message",
          "path": "message",
          "required": false,
          "role": "input"
        },
        {
          "channelId": "parameter-channel:confirmAction:title",
          "path": "title",
          "required": false,
          "role": "input"
        }
      ],
      "resultChannels": [
        {
          "channelId": "result-channel:confirmAction:sha256:1647c22379ab901c1ff246a5f204eef77d589f110e99a202bd8b6406294609df",
          "kind": "host-effect",
          "capabilityId": "host.confirm",
          "operation": "confirm"
        },
        {
          "channelId": "result-channel:confirmAction:sha256:1182f31e9f03c5704bab18950e9381188a2a4411c1380c47c4fce875f9383d02",
          "kind": "return-capture",
          "capture": "step-name"
        }
      ],
      "hostCapabilities": [
        {
          "channelId": "host-channel:confirmAction:sha256:38534ea4073e3c881d3d7bcb224c91a3896839593d920954959c7297a231c0b6",
          "capabilityId": "host.confirm",
          "operation": "confirm"
        }
      ],
      "requiredHostCapabilities": [
        "host.confirm"
      ],
      "missingConsumerPolicy": "block-host"
    },
    {
      "action": "copyToClipboard",
      "runtimeAliases": [],
      "reads": [
        {
          "aliases": [
            "value"
          ],
          "channelId": "parameter-channel:copyToClipboard:text",
          "path": "text",
          "required": false,
          "role": "payload"
        }
      ],
      "resultChannels": [
        {
          "channelId": "result-channel:copyToClipboard:sha256:a847286f47917367bd7910b9b498be65b8f470be059e5cf77a8d9aaff03c3669",
          "kind": "host-effect",
          "capabilityId": "host.clipboard",
          "operation": "write"
        }
      ],
      "hostCapabilities": [
        {
          "channelId": "host-channel:copyToClipboard:sha256:8069d691693dd1fda7ad170ab115fa4a781a8810684471ba5559913e7bf93928",
          "capabilityId": "host.clipboard",
          "operation": "write"
        }
      ],
      "requiredHostCapabilities": [
        "host.clipboard"
      ],
      "missingConsumerPolicy": "block-host"
    },
    {
      "action": "cropImage",
      "runtimeAliases": [],
      "reads": [
        {
          "channelId": "parameter-channel:cropImage:imageId",
          "path": "imageId",
          "required": true,
          "role": "selector"
        },
        {
          "channelId": "parameter-channel:cropImage:ratio",
          "path": "ratio",
          "required": false,
          "role": "input"
        }
      ],
      "resultChannels": [
        {
          "channelId": "result-channel:cropImage:sha256:31d960a73935e24db8bcabd5f2ddeaf4e19f36b696da5797af077da7088f844e",
          "kind": "host-effect",
          "capabilityId": "host.media",
          "operation": "crop-image"
        }
      ],
      "hostCapabilities": [
        {
          "channelId": "host-channel:cropImage:sha256:e0bef232890fd78a109fc887382e81fde88a573d1adb5a1fd7ebb3083876afe0",
          "capabilityId": "host.media",
          "operation": "crop-image"
        }
      ],
      "requiredHostCapabilities": [
        "host.media"
      ],
      "missingConsumerPolicy": "block-host"
    },
    {
      "action": "cryptoAction",
      "runtimeAliases": [],
      "reads": [
        {
          "channelId": "parameter-channel:cryptoAction:algorithm",
          "path": "algorithm",
          "required": false,
          "role": "selector"
        },
        {
          "channelId": "parameter-channel:cryptoAction:data",
          "path": "data",
          "required": false,
          "role": "payload"
        },
        {
          "channelId": "parameter-channel:cryptoAction:key",
          "path": "key",
          "required": false,
          "role": "input"
        },
        {
          "channelId": "parameter-channel:cryptoAction:operation",
          "path": "operation",
          "required": false,
          "role": "selector"
        },
        {
          "channelId": "parameter-channel:cryptoAction:resultPath",
          "path": "resultPath",
          "required": false,
          "role": "target"
        }
      ],
      "resultChannels": [
        {
          "channelId": "result-channel:cryptoAction:sha256:8e337a122c3182a6e78bbfb8db6f4808489d43922a4f2dde0618e50aed1176d1",
          "kind": "host-effect",
          "capabilityId": "host.crypto",
          "operation": "execute"
        },
        {
          "channelId": "result-channel:cryptoAction:sha256:afaa5bdbbfab8eb57e663d7d296d81e7c7e819ca54f4ec64e286e1a46a048c6f",
          "kind": "state-target",
          "targetParam": "resultPath",
          "defaultTarget": "_results.crypto"
        }
      ],
      "hostCapabilities": [
        {
          "channelId": "host-channel:cryptoAction:sha256:8bfa9493f16732a62fab5fdd4fbde058e01a8fd2b1f091b10967031655079938",
          "capabilityId": "host.crypto",
          "operation": "execute"
        }
      ],
      "requiredHostCapabilities": [
        "host.crypto"
      ],
      "missingConsumerPolicy": "block-host"
    },
    {
      "action": "csvExport",
      "runtimeAliases": [],
      "reads": [
        {
          "channelId": "parameter-channel:csvExport:columns",
          "path": "columns",
          "required": false,
          "role": "payload"
        },
        {
          "channelId": "parameter-channel:csvExport:data",
          "path": "data",
          "required": true,
          "role": "payload"
        },
        {
          "channelId": "parameter-channel:csvExport:filename",
          "path": "filename",
          "required": false,
          "role": "input"
        },
        {
          "channelId": "parameter-channel:csvExport:resultTarget",
          "path": "resultTarget",
          "required": false,
          "role": "target"
        }
      ],
      "resultChannels": [
        {
          "channelId": "result-channel:csvExport:sha256:3e5d66844d07271845e3eb20f9f451ba1e0f9132e0bf253ba6d1d8324587a5e3",
          "kind": "host-effect",
          "capabilityId": "host.download",
          "operation": "csv"
        },
        {
          "channelId": "result-channel:csvExport:sha256:c68cc4398252128bb3581e2be941a948b0939b85db3ff156297a2f2c2b12ba49",
          "kind": "state-target",
          "targetParam": "resultTarget",
          "defaultTarget": "_results.csvExport"
        }
      ],
      "hostCapabilities": [
        {
          "channelId": "host-channel:csvExport:sha256:4eb88c47e1a639d4336a30033a9d084c6db3f84e055a507ff5065bd3f942c799",
          "capabilityId": "host.download",
          "operation": "csv"
        }
      ],
      "requiredHostCapabilities": [
        "host.download"
      ],
      "missingConsumerPolicy": "block-host"
    },
    {
      "action": "datasource.call",
      "runtimeAliases": [],
      "reads": [
        {
          "channelId": "parameter-channel:datasource.call:$",
          "path": "$",
          "required": false,
          "role": "payload"
        },
        {
          "aliases": [
            "source"
          ],
          "channelId": "parameter-channel:datasource.call:datasourceId",
          "path": "datasourceId",
          "required": false,
          "role": "selector"
        },
        {
          "aliases": [
            "target"
          ],
          "channelId": "parameter-channel:datasource.call:resultTarget",
          "path": "resultTarget",
          "required": false,
          "role": "target"
        },
        {
          "channelId": "parameter-channel:datasource.call:sourceExpression",
          "path": "sourceExpression",
          "required": false,
          "role": "input"
        }
      ],
      "resultChannels": [
        {
          "channelId": "result-channel:datasource.call:sha256:1182f31e9f03c5704bab18950e9381188a2a4411c1380c47c4fce875f9383d02",
          "kind": "return-capture",
          "capture": "step-name"
        },
        {
          "channelId": "result-channel:datasource.call:sha256:cfa477a83e214c8089a53ed6b0f1b8ef3c0729ade8233b071fd27086dcec6287",
          "kind": "state-target",
          "targetParam": "resultTarget"
        }
      ],
      "hostCapabilities": [],
      "requiredHostCapabilities": [
        "host.datasource"
      ],
      "missingConsumerPolicy": "block-host"
    },
    {
      "action": "debounceAction",
      "runtimeAliases": [],
      "reads": [
        {
          "channelId": "parameter-channel:debounceAction:action",
          "path": "action",
          "required": true,
          "role": "selector"
        },
        {
          "aliases": [
            "wait"
          ],
          "channelId": "parameter-channel:debounceAction:delay",
          "path": "delay",
          "required": false,
          "role": "input"
        },
        {
          "channelId": "parameter-channel:debounceAction:key",
          "path": "key",
          "required": false,
          "role": "selector"
        },
        {
          "channelId": "parameter-channel:debounceAction:leading",
          "path": "leading",
          "required": false,
          "role": "guard"
        },
        {
          "channelId": "parameter-channel:debounceAction:maxWait",
          "path": "maxWait",
          "required": false,
          "role": "input"
        },
        {
          "channelId": "parameter-channel:debounceAction:params",
          "path": "params",
          "required": false,
          "role": "payload"
        },
        {
          "channelId": "parameter-channel:debounceAction:trailing",
          "path": "trailing",
          "required": false,
          "role": "guard"
        }
      ],
      "resultChannels": [],
      "hostCapabilities": [],
      "requiredHostCapabilities": [],
      "missingConsumerPolicy": "reject-before-side-effects"
    },
    {
      "action": "delay",
      "runtimeAliases": [],
      "reads": [
        {
          "aliases": [
            "ms"
          ],
          "channelId": "parameter-channel:delay:duration",
          "path": "duration",
          "required": false,
          "role": "input"
        },
        {
          "channelId": "parameter-channel:delay:unit",
          "path": "unit",
          "required": false,
          "role": "selector"
        }
      ],
      "resultChannels": [],
      "hostCapabilities": [],
      "requiredHostCapabilities": [],
      "missingConsumerPolicy": "reject-before-side-effects"
    },
    {
      "action": "deleteTableRow",
      "runtimeAliases": [],
      "reads": [
        {
          "channelId": "parameter-channel:deleteTableRow:rowIndex",
          "path": "rowIndex",
          "required": true,
          "role": "selector"
        },
        {
          "channelId": "parameter-channel:deleteTableRow:target",
          "path": "target",
          "required": true,
          "role": "target"
        }
      ],
      "resultChannels": [
        {
          "channelId": "result-channel:deleteTableRow:sha256:5e680edc286f76bc1908e751533aa390759ed7860011a389f683935f75cfda7b",
          "kind": "state-target",
          "targetParam": "target"
        }
      ],
      "hostCapabilities": [],
      "requiredHostCapabilities": [],
      "missingConsumerPolicy": "reject-before-side-effects"
    },
    {
      "action": "dispatchStoreAction",
      "runtimeAliases": [],
      "reads": [
        {
          "channelId": "parameter-channel:dispatchStoreAction:handler",
          "path": "handler",
          "required": true,
          "role": "selector"
        },
        {
          "channelId": "parameter-channel:dispatchStoreAction:params",
          "path": "params",
          "required": false,
          "role": "payload"
        }
      ],
      "resultChannels": [
        {
          "channelId": "result-channel:dispatchStoreAction:sha256:4c81038a9e12e291c5d34b39f80146ba1397ac036e9b266b87792b42ca2c4342",
          "kind": "host-registry",
          "capabilityId": "host.store-action",
          "selectorParam": "handler",
          "payloadParam": "params"
        }
      ],
      "hostCapabilities": [
        {
          "channelId": "host-channel:dispatchStoreAction:sha256:107fc82a092a88d5b70d4d996c864964ecdaf17b9dded72650b5443ac896e631",
          "capabilityId": "host.store-action",
          "operation": "invoke"
        }
      ],
      "requiredHostCapabilities": [
        "host.store-action"
      ],
      "missingConsumerPolicy": "block-host"
    },
    {
      "action": "downloadAction",
      "runtimeAliases": [],
      "reads": [
        {
          "channelId": "parameter-channel:downloadAction:filename",
          "path": "filename",
          "required": false,
          "role": "input"
        },
        {
          "channelId": "parameter-channel:downloadAction:headers",
          "path": "headers",
          "required": false,
          "role": "payload"
        },
        {
          "channelId": "parameter-channel:downloadAction:url",
          "path": "url",
          "required": true,
          "role": "input"
        }
      ],
      "resultChannels": [
        {
          "channelId": "result-channel:downloadAction:sha256:252314cbe22caa39be75b8096b4e84eae1c2ae87adee7d86850256ce9d27cd94",
          "kind": "host-effect",
          "capabilityId": "host.download",
          "operation": "download"
        },
        {
          "channelId": "result-channel:downloadAction:sha256:495468431c60297647ef4121fb3c688160a0ea488825c83f444dc5fafde49b7f",
          "kind": "host-effect",
          "when": {
            "param": "headers",
            "present": true
          },
          "capabilityId": "host.download",
          "operation": "download"
        },
        {
          "channelId": "result-channel:downloadAction:sha256:acae841e2fe57cdfd7f8abad370e62e4063be2b759a7839c034fdb4a07dd1586",
          "kind": "host-effect",
          "when": {
            "param": "headers",
            "present": true
          },
          "capabilityId": "host.fetch",
          "operation": "fetch-with-headers"
        }
      ],
      "hostCapabilities": [
        {
          "channelId": "host-channel:downloadAction:sha256:1fbddf5ceefbcb226b20f2af84456b28afe9e493a1d3c52cb9eea42a870cee6b",
          "capabilityId": "host.download",
          "operation": "download"
        },
        {
          "channelId": "host-channel:downloadAction:sha256:e5a6ad624949fdee93f444ca2b2f7aa55331903632f55e8f1c59498112ea031f",
          "capabilityId": "host.download",
          "operation": "download",
          "when": {
            "param": "headers",
            "present": true
          }
        },
        {
          "channelId": "host-channel:downloadAction:sha256:570a600a57c9d6ae1bf2949fbc73c0a6b7c80fa1f835956d895f3aaebe65b9ef",
          "capabilityId": "host.fetch",
          "operation": "fetch-with-headers",
          "when": {
            "param": "headers",
            "present": true
          }
        }
      ],
      "requiredHostCapabilities": [
        "host.download"
      ],
      "missingConsumerPolicy": "block-host"
    },
    {
      "action": "emitEvent",
      "runtimeAliases": [
        "emit"
      ],
      "reads": [
        {
          "aliases": [
            "payload"
          ],
          "channelId": "parameter-channel:emitEvent:data",
          "path": "data",
          "required": false,
          "role": "payload"
        },
        {
          "aliases": [
            "eventName",
            "name"
          ],
          "channelId": "parameter-channel:emitEvent:event",
          "path": "event",
          "required": true,
          "role": "selector"
        }
      ],
      "resultChannels": [
        {
          "channelId": "result-channel:emitEvent:sha256:aa2286141df53445921eac465e25ced88872643bc0afa391df8c41710ed0bdd9",
          "kind": "host-effect",
          "capabilityId": "host.event-bus",
          "operation": "emit"
        }
      ],
      "hostCapabilities": [
        {
          "channelId": "host-channel:emitEvent:sha256:4493a1b02cf9c435d79090456686c7bd4254369bec3a41224367fce1e1fdd2dd",
          "capabilityId": "host.event-bus",
          "operation": "emit"
        }
      ],
      "requiredHostCapabilities": [
        "host.event-bus"
      ],
      "missingConsumerPolicy": "block-host"
    },
    {
      "action": "fileUpload",
      "runtimeAliases": [],
      "reads": [
        {
          "channelId": "parameter-channel:fileUpload:accept",
          "path": "accept",
          "required": false,
          "role": "input"
        },
        {
          "channelId": "parameter-channel:fileUpload:field",
          "path": "field",
          "required": false,
          "role": "selector"
        },
        {
          "channelId": "parameter-channel:fileUpload:maxSize",
          "path": "maxSize",
          "required": false,
          "role": "guard"
        },
        {
          "channelId": "parameter-channel:fileUpload:resultPath",
          "path": "resultPath",
          "required": false,
          "role": "target"
        },
        {
          "channelId": "parameter-channel:fileUpload:url",
          "path": "url",
          "required": false,
          "role": "input"
        }
      ],
      "resultChannels": [
        {
          "channelId": "result-channel:fileUpload:sha256:d6aeb764f079b83284b6ae66d943e17b99fa63da5d8b1ef9fe4c25047ce0d4b8",
          "kind": "host-effect",
          "capabilityId": "host.file-picker",
          "operation": "pick-and-upload"
        },
        {
          "channelId": "result-channel:fileUpload:sha256:e0014257c41211bc120105c8886e5b6c3a4688335ebf7365886187abb0843093",
          "kind": "state-target",
          "targetParam": "resultPath",
          "defaultTarget": "_results.file"
        }
      ],
      "hostCapabilities": [
        {
          "channelId": "host-channel:fileUpload:sha256:57c2e990f49e615953941f87eb41f1e822754d63a91d4b0b972cce2795ecf5b9",
          "capabilityId": "host.file-picker",
          "operation": "pick-and-upload"
        }
      ],
      "requiredHostCapabilities": [
        "host.fetch",
        "host.file-picker"
      ],
      "missingConsumerPolicy": "block-host"
    },
    {
      "action": "geminiAction",
      "runtimeAliases": [],
      "reads": [
        {
          "channelId": "parameter-channel:geminiAction:apiKey",
          "path": "apiKey",
          "required": false,
          "role": "input"
        },
        {
          "channelId": "parameter-channel:geminiAction:exposedActions",
          "path": "exposedActions",
          "required": false,
          "role": "payload"
        },
        {
          "channelId": "parameter-channel:geminiAction:maxToolCalls",
          "path": "maxToolCalls",
          "required": false,
          "role": "guard"
        },
        {
          "channelId": "parameter-channel:geminiAction:model",
          "path": "model",
          "required": false,
          "role": "selector"
        },
        {
          "channelId": "parameter-channel:geminiAction:prompt",
          "path": "prompt",
          "required": false,
          "role": "input"
        },
        {
          "channelId": "parameter-channel:geminiAction:resultTarget",
          "path": "resultTarget",
          "required": false,
          "role": "target"
        }
      ],
      "resultChannels": [
        {
          "channelId": "result-channel:geminiAction:sha256:21bf98de214eff4573eca42edfa55d148568c3c1cf177d93cef9ad2a7f1b1463",
          "kind": "state-target",
          "targetParam": "resultTarget",
          "defaultTarget": "_results.gemini"
        }
      ],
      "hostCapabilities": [],
      "requiredHostCapabilities": [
        "host.gemini"
      ],
      "missingConsumerPolicy": "block-host"
    },
    {
      "action": "geminiFunctionCall",
      "runtimeAliases": [],
      "reads": [
        {
          "channelId": "parameter-channel:geminiFunctionCall:apiKey",
          "path": "apiKey",
          "required": false,
          "role": "input"
        },
        {
          "channelId": "parameter-channel:geminiFunctionCall:maxTurns",
          "path": "maxTurns",
          "required": false,
          "role": "guard"
        },
        {
          "channelId": "parameter-channel:geminiFunctionCall:model",
          "path": "model",
          "required": false,
          "role": "selector"
        },
        {
          "channelId": "parameter-channel:geminiFunctionCall:prompt",
          "path": "prompt",
          "required": true,
          "role": "input"
        },
        {
          "channelId": "parameter-channel:geminiFunctionCall:resultTarget",
          "path": "resultTarget",
          "required": false,
          "role": "target"
        },
        {
          "channelId": "parameter-channel:geminiFunctionCall:systemPrompt",
          "path": "systemPrompt",
          "required": false,
          "role": "input"
        },
        {
          "channelId": "parameter-channel:geminiFunctionCall:tokenBudget",
          "path": "tokenBudget",
          "required": false,
          "role": "guard"
        },
        {
          "channelId": "parameter-channel:geminiFunctionCall:tools",
          "path": "tools",
          "required": false,
          "role": "payload"
        }
      ],
      "resultChannels": [
        {
          "channelId": "result-channel:geminiFunctionCall:sha256:b5fb59896c2c37f9703ad8507d1fe9719ad55e9aea23d9a0e08ab34287b292fb",
          "kind": "state-target",
          "targetParam": "resultTarget",
          "defaultTarget": "_results.agent"
        }
      ],
      "hostCapabilities": [],
      "requiredHostCapabilities": [
        "host.gemini"
      ],
      "missingConsumerPolicy": "block-host"
    },
    {
      "action": "geminiStream",
      "runtimeAliases": [],
      "reads": [
        {
          "channelId": "parameter-channel:geminiStream:model",
          "path": "model",
          "required": false,
          "role": "input"
        },
        {
          "channelId": "parameter-channel:geminiStream:prompt",
          "path": "prompt",
          "required": true,
          "role": "input"
        },
        {
          "channelId": "parameter-channel:geminiStream:resultTarget",
          "path": "resultTarget",
          "required": false,
          "role": "target"
        },
        {
          "channelId": "parameter-channel:geminiStream:streamId",
          "path": "streamId",
          "required": false,
          "role": "selector"
        }
      ],
      "resultChannels": [
        {
          "channelId": "result-channel:geminiStream:sha256:cfb9212766040825bc935dcb8e37e20a7b65fe00698a89adbb4f3658caa0490c",
          "kind": "state-target",
          "targetParam": "resultTarget",
          "defaultTarget": "_results.stream"
        }
      ],
      "hostCapabilities": [],
      "requiredHostCapabilities": [
        "host.ai-stream"
      ],
      "missingConsumerPolicy": "block-host"
    },
    {
      "action": "geminiVision",
      "runtimeAliases": [],
      "reads": [
        {
          "channelId": "parameter-channel:geminiVision:apiKey",
          "path": "apiKey",
          "required": false,
          "role": "input"
        },
        {
          "channelId": "parameter-channel:geminiVision:imageBase64",
          "path": "imageBase64",
          "required": false,
          "role": "payload"
        },
        {
          "channelId": "parameter-channel:geminiVision:imageUrl",
          "path": "imageUrl",
          "required": false,
          "role": "input"
        },
        {
          "channelId": "parameter-channel:geminiVision:images",
          "path": "images",
          "required": false,
          "role": "payload"
        },
        {
          "channelId": "parameter-channel:geminiVision:mimeType",
          "path": "mimeType",
          "required": false,
          "role": "input"
        },
        {
          "channelId": "parameter-channel:geminiVision:model",
          "path": "model",
          "required": false,
          "role": "selector"
        },
        {
          "channelId": "parameter-channel:geminiVision:prompt",
          "path": "prompt",
          "required": false,
          "role": "input"
        },
        {
          "channelId": "parameter-channel:geminiVision:resultTarget",
          "path": "resultTarget",
          "required": false,
          "role": "target"
        }
      ],
      "resultChannels": [
        {
          "channelId": "result-channel:geminiVision:sha256:4db46be8fb19e0d969e20b13450f245a7bdabc2ca623a19bd20afe4600c3fdbc",
          "kind": "state-target",
          "targetParam": "resultTarget",
          "defaultTarget": "_results.vision"
        }
      ],
      "hostCapabilities": [],
      "requiredHostCapabilities": [
        "host.gemini"
      ],
      "missingConsumerPolicy": "block-host"
    },
    {
      "action": "geolocation",
      "runtimeAliases": [],
      "reads": [
        {
          "channelId": "parameter-channel:geolocation:accuracy",
          "path": "accuracy",
          "required": false,
          "role": "selector"
        },
        {
          "channelId": "parameter-channel:geolocation:resultPath",
          "path": "resultPath",
          "required": false,
          "role": "target"
        },
        {
          "channelId": "parameter-channel:geolocation:timeout",
          "path": "timeout",
          "required": false,
          "role": "input"
        }
      ],
      "resultChannels": [
        {
          "channelId": "result-channel:geolocation:sha256:959390f841bbde6f8feaf8ef954241c805e3e29b80b4c00188813928d56c15a6",
          "kind": "host-effect",
          "capabilityId": "host.geolocation",
          "operation": "get"
        },
        {
          "channelId": "result-channel:geolocation:sha256:90566fb667a3d359ed4c833ef923037ee976570d13691220de65555d67a769a1",
          "kind": "state-target",
          "targetParam": "resultPath",
          "defaultTarget": "_results.geo"
        }
      ],
      "hostCapabilities": [
        {
          "channelId": "host-channel:geolocation:sha256:9b8a16576997fd6651ee174d6f636e681a5bcaad9815e3032a116f8c26445df1",
          "capabilityId": "host.geolocation",
          "operation": "get"
        }
      ],
      "requiredHostCapabilities": [
        "host.geolocation"
      ],
      "missingConsumerPolicy": "block-host"
    },
    {
      "action": "goLink",
      "runtimeAliases": [],
      "reads": [
        {
          "channelId": "parameter-channel:goLink:newTab",
          "path": "newTab",
          "required": false,
          "role": "guard"
        },
        {
          "channelId": "parameter-channel:goLink:url",
          "path": "url",
          "required": true,
          "role": "input"
        }
      ],
      "resultChannels": [
        {
          "channelId": "result-channel:goLink:sha256:66080c57fb1b924a01de73826b35f350eb8b265ca2272038f9877e0b1976d0ca",
          "kind": "host-effect",
          "capabilityId": "host.navigation",
          "operation": "open-external"
        }
      ],
      "hostCapabilities": [
        {
          "channelId": "host-channel:goLink:sha256:5285fc8bd9638ace0efaf2a8df9e506111ad886afa82412b15878dab8174acf1",
          "capabilityId": "host.navigation",
          "operation": "open-external"
        }
      ],
      "requiredHostCapabilities": [
        "host.navigation"
      ],
      "missingConsumerPolicy": "block-host"
    },
    {
      "action": "googleFcm",
      "runtimeAliases": [],
      "reads": [
        {
          "channelId": "parameter-channel:googleFcm:body",
          "path": "body",
          "required": true,
          "role": "payload"
        },
        {
          "channelId": "parameter-channel:googleFcm:data",
          "path": "data",
          "required": false,
          "role": "payload"
        },
        {
          "channelId": "parameter-channel:googleFcm:resultTarget",
          "path": "resultTarget",
          "required": false,
          "role": "target"
        },
        {
          "channelId": "parameter-channel:googleFcm:title",
          "path": "title",
          "required": true,
          "role": "input"
        },
        {
          "channelId": "parameter-channel:googleFcm:token",
          "path": "token",
          "required": false,
          "role": "input"
        },
        {
          "channelId": "parameter-channel:googleFcm:userId",
          "path": "userId",
          "required": false,
          "role": "input"
        }
      ],
      "resultChannels": [
        {
          "channelId": "result-channel:googleFcm:sha256:188f5e326bcb99af6fcb82a92b80cdf6d25a4e313e13c45199666b70632f191a",
          "kind": "state-target",
          "targetParam": "resultTarget",
          "defaultTarget": "_results.googleFcm"
        }
      ],
      "hostCapabilities": [],
      "requiredHostCapabilities": [
        "host.google-api"
      ],
      "missingConsumerPolicy": "block-host"
    },
    {
      "action": "googleGmail",
      "runtimeAliases": [],
      "reads": [
        {
          "channelId": "parameter-channel:googleGmail:bcc",
          "path": "bcc",
          "required": false,
          "role": "input"
        },
        {
          "channelId": "parameter-channel:googleGmail:body",
          "path": "body",
          "required": true,
          "role": "payload"
        },
        {
          "channelId": "parameter-channel:googleGmail:cc",
          "path": "cc",
          "required": false,
          "role": "input"
        },
        {
          "channelId": "parameter-channel:googleGmail:resultTarget",
          "path": "resultTarget",
          "required": false,
          "role": "target"
        },
        {
          "channelId": "parameter-channel:googleGmail:subject",
          "path": "subject",
          "required": true,
          "role": "input"
        },
        {
          "channelId": "parameter-channel:googleGmail:to",
          "path": "to",
          "required": true,
          "role": "input"
        }
      ],
      "resultChannels": [
        {
          "channelId": "result-channel:googleGmail:sha256:9eab7ddc891f92b1292b961d11f46afe0a37f2c637b3ea7d1d3ec4caa506c9ee",
          "kind": "state-target",
          "targetParam": "resultTarget",
          "defaultTarget": "_results.googleGmail"
        }
      ],
      "hostCapabilities": [],
      "requiredHostCapabilities": [
        "host.google-api"
      ],
      "missingConsumerPolicy": "block-host"
    },
    {
      "action": "graphqlAction",
      "runtimeAliases": [],
      "reads": [
        {
          "channelId": "parameter-channel:graphqlAction:headers",
          "path": "headers",
          "required": false,
          "role": "payload"
        },
        {
          "channelId": "parameter-channel:graphqlAction:query",
          "path": "query",
          "required": true,
          "role": "payload"
        },
        {
          "aliases": [
            "resultPath"
          ],
          "channelId": "parameter-channel:graphqlAction:resultTarget",
          "path": "resultTarget",
          "required": false,
          "role": "target"
        },
        {
          "aliases": [
            "endpoint"
          ],
          "channelId": "parameter-channel:graphqlAction:url",
          "path": "url",
          "required": true,
          "role": "input"
        },
        {
          "channelId": "parameter-channel:graphqlAction:variables",
          "path": "variables",
          "required": false,
          "role": "payload"
        }
      ],
      "resultChannels": [
        {
          "channelId": "result-channel:graphqlAction:sha256:fb1264ee5b1547a360f7664395a913d25d446370db7026e50214a907e8bad0f9",
          "kind": "state-target",
          "targetParam": "resultTarget",
          "defaultTarget": "_results.graphql"
        }
      ],
      "hostCapabilities": [],
      "requiredHostCapabilities": [
        "host.fetch"
      ],
      "missingConsumerPolicy": "block-host"
    },
    {
      "action": "groupBy",
      "runtimeAliases": [],
      "reads": [
        {
          "channelId": "parameter-channel:groupBy:keyField",
          "path": "keyField",
          "required": true,
          "role": "selector"
        },
        {
          "channelId": "parameter-channel:groupBy:keySlice",
          "path": "keySlice",
          "required": false,
          "role": "input"
        },
        {
          "channelId": "parameter-channel:groupBy:source",
          "path": "source",
          "required": true,
          "role": "input"
        },
        {
          "channelId": "parameter-channel:groupBy:sumFields",
          "path": "sumFields",
          "required": false,
          "role": "payload"
        },
        {
          "channelId": "parameter-channel:groupBy:target",
          "path": "target",
          "required": true,
          "role": "target"
        }
      ],
      "resultChannels": [
        {
          "channelId": "result-channel:groupBy:sha256:5e680edc286f76bc1908e751533aa390759ed7860011a389f683935f75cfda7b",
          "kind": "state-target",
          "targetParam": "target"
        }
      ],
      "hostCapabilities": [],
      "requiredHostCapabilities": [],
      "missingConsumerPolicy": "reject-before-side-effects"
    },
    {
      "action": "invokeCallback",
      "runtimeAliases": [
        "callback",
        "callback_action"
      ],
      "reads": [
        {
          "aliases": [
            "params"
          ],
          "channelId": "parameter-channel:invokeCallback:args",
          "path": "args",
          "required": false,
          "role": "payload"
        },
        {
          "aliases": [
            "callbackId"
          ],
          "channelId": "parameter-channel:invokeCallback:callback",
          "path": "callback",
          "required": true,
          "role": "selector"
        }
      ],
      "resultChannels": [
        {
          "channelId": "result-channel:invokeCallback:sha256:2b43c6b4aa43c257c053549c4ca0b24d473dd3fc4fb8baebee21af8f511ccc64",
          "kind": "host-registry",
          "capabilityId": "host.callback",
          "selectorParam": "callback",
          "payloadParam": "args"
        }
      ],
      "hostCapabilities": [
        {
          "channelId": "host-channel:invokeCallback:sha256:21dfb056e765d2d77ee1909377967462375530b9ed30eb0cf84f0a43b06b6507",
          "capabilityId": "host.callback",
          "operation": "invoke"
        }
      ],
      "requiredHostCapabilities": [
        "host.callback"
      ],
      "missingConsumerPolicy": "block-host"
    },
    {
      "action": "invokeNativeSignatureAgent",
      "runtimeAliases": [],
      "reads": [
        {
          "channelId": "parameter-channel:invokeNativeSignatureAgent:agentRef",
          "path": "agentRef",
          "required": false,
          "role": "selector"
        },
        {
          "channelId": "parameter-channel:invokeNativeSignatureAgent:method",
          "path": "method",
          "required": true,
          "role": "selector"
        },
        {
          "channelId": "parameter-channel:invokeNativeSignatureAgent:payload",
          "path": "payload",
          "required": false,
          "role": "payload"
        },
        {
          "channelId": "parameter-channel:invokeNativeSignatureAgent:resultTarget",
          "path": "resultTarget",
          "required": false,
          "role": "target"
        }
      ],
      "resultChannels": [
        {
          "channelId": "result-channel:invokeNativeSignatureAgent:sha256:e17e8580a461db1ee27e2733c113a2b794f4a833d162a2c6c57b95b32ba05814",
          "kind": "host-effect",
          "capabilityId": "host.native-signature-agent",
          "operation": "invoke"
        },
        {
          "channelId": "result-channel:invokeNativeSignatureAgent:sha256:296350bdc75d159e6d4d57cb9d4e84cb8fbc93c6437fc2fdb64582d30953f24a",
          "kind": "state-target",
          "targetParam": "resultTarget",
          "defaultTarget": "_results.nativeSignatureAgent"
        }
      ],
      "hostCapabilities": [
        {
          "channelId": "host-channel:invokeNativeSignatureAgent:sha256:cf28472c952c23b622631812e550da138acc4974a027107ac1d7dba765978bff",
          "capabilityId": "host.native-signature-agent",
          "operation": "invoke"
        }
      ],
      "requiredHostCapabilities": [
        "host.native-signature-agent"
      ],
      "missingConsumerPolicy": "block-host"
    },
    {
      "action": "jsonExport",
      "runtimeAliases": [],
      "reads": [
        {
          "channelId": "parameter-channel:jsonExport:data",
          "path": "data",
          "required": true,
          "role": "payload"
        },
        {
          "channelId": "parameter-channel:jsonExport:filename",
          "path": "filename",
          "required": false,
          "role": "input"
        },
        {
          "channelId": "parameter-channel:jsonExport:resultTarget",
          "path": "resultTarget",
          "required": false,
          "role": "target"
        }
      ],
      "resultChannels": [
        {
          "channelId": "result-channel:jsonExport:sha256:a757c16dc5cbb93c2e907d4e6ae80e2abc26a041c16a86e80fd4adb14fd9d7f8",
          "kind": "host-effect",
          "capabilityId": "host.download",
          "operation": "json"
        },
        {
          "channelId": "result-channel:jsonExport:sha256:4e60b88efabffaca96f7d7bea8a53e62cf0fd024936d5d6928b97fac13d0dc94",
          "kind": "state-target",
          "targetParam": "resultTarget",
          "defaultTarget": "_results.jsonExport"
        }
      ],
      "hostCapabilities": [
        {
          "channelId": "host-channel:jsonExport:sha256:be81485a715f2093509c7f94b89a768d37a770fc07a8931bb097e8e231b5685b",
          "capabilityId": "host.download",
          "operation": "json"
        }
      ],
      "requiredHostCapabilities": [
        "host.download"
      ],
      "missingConsumerPolicy": "block-host"
    },
    {
      "action": "loadDatasource",
      "runtimeAliases": [
        "loadDataSource"
      ],
      "reads": [
        {
          "channelId": "parameter-channel:loadDatasource:body",
          "path": "body",
          "required": false,
          "role": "payload"
        },
        {
          "aliases": [
            "source"
          ],
          "channelId": "parameter-channel:loadDatasource:datasourceId",
          "path": "datasourceId",
          "required": true,
          "role": "selector"
        },
        {
          "channelId": "parameter-channel:loadDatasource:method",
          "path": "method",
          "required": false,
          "role": "selector"
        },
        {
          "channelId": "parameter-channel:loadDatasource:query",
          "path": "query",
          "required": false,
          "role": "payload"
        },
        {
          "aliases": [
            "target"
          ],
          "channelId": "parameter-channel:loadDatasource:resultTarget",
          "path": "resultTarget",
          "required": false,
          "role": "target"
        }
      ],
      "resultChannels": [
        {
          "channelId": "result-channel:loadDatasource:sha256:c7e5e89e0c5e00c9c70109fd28fe919e517267560d534d948983f4c25988d245",
          "kind": "host-effect",
          "capabilityId": "host.datasource",
          "operation": "load"
        },
        {
          "channelId": "result-channel:loadDatasource:sha256:cfa477a83e214c8089a53ed6b0f1b8ef3c0729ade8233b071fd27086dcec6287",
          "kind": "state-target",
          "targetParam": "resultTarget"
        }
      ],
      "hostCapabilities": [
        {
          "channelId": "host-channel:loadDatasource:sha256:a66c15243921e6f0ee497f724bdf9c26aca461f208f45b89bc01aa4d96a81a43",
          "capabilityId": "host.datasource",
          "operation": "load"
        }
      ],
      "requiredHostCapabilities": [
        "host.datasource"
      ],
      "missingConsumerPolicy": "block-host"
    },
    {
      "action": "log",
      "runtimeAliases": [],
      "reads": [
        {
          "channelId": "parameter-channel:log:data",
          "path": "data",
          "required": false,
          "role": "payload"
        },
        {
          "channelId": "parameter-channel:log:level",
          "path": "level",
          "required": false,
          "role": "selector"
        },
        {
          "channelId": "parameter-channel:log:message",
          "path": "message",
          "required": false,
          "role": "input"
        },
        {
          "channelId": "parameter-channel:log:value",
          "path": "value",
          "required": false,
          "role": "payload"
        }
      ],
      "resultChannels": [
        {
          "channelId": "result-channel:log:sha256:5e5c0f0ba23ca781faebfa7879865b77de79c8ab7dd9f0b38f9aaa702e4793c7",
          "kind": "host-effect",
          "capabilityId": "host.console",
          "operation": "log"
        }
      ],
      "hostCapabilities": [
        {
          "channelId": "host-channel:log:sha256:b150cf183fbb98dba2b860ace3f6f03858f2f10c4fbdff867d7a62e2737a32a6",
          "capabilityId": "host.console",
          "operation": "log"
        }
      ],
      "requiredHostCapabilities": [
        "host.console"
      ],
      "missingConsumerPolicy": "block-host"
    },
    {
      "action": "mediaCapture",
      "runtimeAliases": [],
      "reads": [
        {
          "channelId": "parameter-channel:mediaCapture:audio",
          "path": "audio",
          "required": false,
          "role": "guard"
        },
        {
          "channelId": "parameter-channel:mediaCapture:maxDuration",
          "path": "maxDuration",
          "required": false,
          "role": "input"
        },
        {
          "channelId": "parameter-channel:mediaCapture:quality",
          "path": "quality",
          "required": false,
          "role": "payload"
        },
        {
          "channelId": "parameter-channel:mediaCapture:resultPath",
          "path": "resultPath",
          "required": false,
          "role": "target"
        },
        {
          "channelId": "parameter-channel:mediaCapture:source",
          "path": "source",
          "required": false,
          "role": "selector"
        },
        {
          "channelId": "parameter-channel:mediaCapture:type",
          "path": "type",
          "required": false,
          "role": "selector"
        }
      ],
      "resultChannels": [
        {
          "channelId": "result-channel:mediaCapture:sha256:6dbf45b312dffd09ac5e951358f2991a8b0c9efddd90b6ead6f395f70b3ec4a5",
          "kind": "host-effect",
          "capabilityId": "host.media",
          "operation": "capture"
        },
        {
          "channelId": "result-channel:mediaCapture:sha256:70602f4574b0b42309b1585925c198b233ef44ac4199aa87699faad74a4d5f58",
          "kind": "state-target",
          "targetParam": "resultPath",
          "defaultTarget": "_results.media"
        }
      ],
      "hostCapabilities": [
        {
          "channelId": "host-channel:mediaCapture:sha256:e510273d0941dad0c7b2de43a2c77b5768506a4c8c8280f405597ea33bd51cef",
          "capabilityId": "host.media",
          "operation": "capture"
        }
      ],
      "requiredHostCapabilities": [
        "host.media"
      ],
      "missingConsumerPolicy": "block-host"
    },
    {
      "action": "mediaControl",
      "runtimeAliases": [],
      "reads": [
        {
          "channelId": "parameter-channel:mediaControl:$",
          "path": "$",
          "required": false,
          "role": "payload"
        },
        {
          "channelId": "parameter-channel:mediaControl:command",
          "path": "command",
          "required": true,
          "role": "selector"
        }
      ],
      "resultChannels": [
        {
          "channelId": "result-channel:mediaControl:sha256:f13e0545cdcb840e991d93d57ed408c012e659fe5a63c36b0ade75371a291639",
          "kind": "host-effect",
          "capabilityId": "host.media",
          "operation": "control"
        }
      ],
      "hostCapabilities": [
        {
          "channelId": "host-channel:mediaControl:sha256:f13f4f066b3c4ca540086792a9f4a588a82d10a55d0ddd8fd85b4fc6c067115a",
          "capabilityId": "host.media",
          "operation": "control"
        }
      ],
      "requiredHostCapabilities": [
        "host.media"
      ],
      "missingConsumerPolicy": "block-host"
    },
    {
      "action": "navigate",
      "runtimeAliases": [],
      "reads": [
        {
          "channelId": "parameter-channel:navigate:mode",
          "path": "mode",
          "required": false,
          "role": "selector"
        },
        {
          "channelId": "parameter-channel:navigate:params",
          "path": "params",
          "required": false,
          "role": "payload"
        },
        {
          "aliases": [
            "route",
            "target"
          ],
          "channelId": "parameter-channel:navigate:to",
          "path": "to",
          "required": true,
          "role": "input"
        },
        {
          "channelId": "parameter-channel:navigate:transition",
          "path": "transition",
          "required": false,
          "role": "input"
        }
      ],
      "resultChannels": [
        {
          "channelId": "result-channel:navigate:sha256:2151bc55ade9830b0f8a14a5cf4a925cb79cdd4bcb9f055bec16244c4fee2c1c",
          "kind": "host-effect",
          "when": {
            "param": "mode",
            "equals": [
              "replace"
            ]
          },
          "capabilityId": "host.navigation",
          "operation": "replace"
        },
        {
          "channelId": "result-channel:navigate:sha256:4ae807492650a85d868c8c47827b770335b0f30b3a7495c3609330f7f022c214",
          "kind": "host-effect",
          "capabilityId": "host.navigation",
          "operation": "push"
        }
      ],
      "hostCapabilities": [
        {
          "channelId": "host-channel:navigate:sha256:6cd3f9fc53bc43cc8bfa4f64ca2846c3347f9d21331d4d8d80aaad6926f38192",
          "capabilityId": "host.navigation",
          "operation": "push"
        },
        {
          "channelId": "host-channel:navigate:sha256:9828a0ea4ace451e3a88dd49ca75ab04fc2242125bed7c20c34eeb060991a4ef",
          "capabilityId": "host.navigation",
          "operation": "replace",
          "when": {
            "param": "mode",
            "equals": [
              "replace"
            ]
          }
        }
      ],
      "requiredHostCapabilities": [
        "host.navigation"
      ],
      "missingConsumerPolicy": "block-host"
    },
    {
      "action": "notification",
      "runtimeAliases": [],
      "reads": [
        {
          "channelId": "parameter-channel:notification:body",
          "path": "body",
          "required": false,
          "role": "payload"
        },
        {
          "channelId": "parameter-channel:notification:title",
          "path": "title",
          "required": true,
          "role": "input"
        }
      ],
      "resultChannels": [
        {
          "channelId": "result-channel:notification:sha256:42b086bb009a6562c4df095fcf5d721acb67f11939c6b6a3a61ba730cccb2ea5",
          "kind": "host-effect",
          "capabilityId": "host.notification",
          "operation": "show"
        }
      ],
      "hostCapabilities": [
        {
          "channelId": "host-channel:notification:sha256:2dc44d6003786820676d7fcdaeaea01dfe928f69b761c83a0b6f9436edc8bf9a",
          "capabilityId": "host.notification",
          "operation": "show"
        }
      ],
      "requiredHostCapabilities": [
        "host.notification"
      ],
      "missingConsumerPolicy": "block-host"
    },
    {
      "action": "openAuthSession",
      "runtimeAliases": [],
      "reads": [
        {
          "channelId": "parameter-channel:openAuthSession:redirectUrl",
          "path": "redirectUrl",
          "required": false,
          "role": "input"
        },
        {
          "channelId": "parameter-channel:openAuthSession:resultTarget",
          "path": "resultTarget",
          "required": false,
          "role": "target"
        },
        {
          "channelId": "parameter-channel:openAuthSession:url",
          "path": "url",
          "required": true,
          "role": "input"
        }
      ],
      "resultChannels": [
        {
          "channelId": "result-channel:openAuthSession:sha256:9863e9e9712752e8b4094ec292633dc275332107221b744b5478e44ea4e88228",
          "kind": "host-effect",
          "capabilityId": "host.auth-session",
          "operation": "open"
        },
        {
          "channelId": "result-channel:openAuthSession:sha256:3273ed7786f42f8550b811d5879423d01aaebbcbc7348d350c8f8b69ced4c37e",
          "kind": "state-target",
          "targetParam": "resultTarget",
          "defaultTarget": "_results.auth"
        }
      ],
      "hostCapabilities": [
        {
          "channelId": "host-channel:openAuthSession:sha256:7da989ae9ff0ff980091cf8339be5efcac49da4f55b1f055dd66b41a505ae9d7",
          "capabilityId": "host.auth-session",
          "operation": "open"
        }
      ],
      "requiredHostCapabilities": [
        "host.auth-session"
      ],
      "missingConsumerPolicy": "block-host"
    },
    {
      "action": "openModal",
      "runtimeAliases": [],
      "reads": [
        {
          "channelId": "parameter-channel:openModal:$",
          "path": "$",
          "required": false,
          "role": "payload"
        },
        {
          "aliases": [
            "popup"
          ],
          "channelId": "parameter-channel:openModal:modalId",
          "path": "modalId",
          "required": true,
          "role": "selector"
        }
      ],
      "resultChannels": [
        {
          "channelId": "result-channel:openModal:sha256:d3f8cbf33caf931a6842464bc1f581435c0fc83fed4a4b539565d2136ddcc932",
          "kind": "host-effect",
          "capabilityId": "host.modal",
          "operation": "open"
        }
      ],
      "hostCapabilities": [
        {
          "channelId": "host-channel:openModal:sha256:51808fbad2b06db48792fb314061a49207063fc90e33b8f987ddb716c4790131",
          "capabilityId": "host.modal",
          "operation": "open"
        }
      ],
      "requiredHostCapabilities": [
        "host.modal"
      ],
      "missingConsumerPolicy": "block-host"
    },
    {
      "action": "openNativeFilePicker",
      "runtimeAliases": [],
      "reads": [
        {
          "channelId": "parameter-channel:openNativeFilePicker:accept",
          "path": "accept",
          "required": false,
          "role": "input"
        },
        {
          "channelId": "parameter-channel:openNativeFilePicker:multiple",
          "path": "multiple",
          "required": false,
          "role": "guard"
        }
      ],
      "resultChannels": [
        {
          "channelId": "result-channel:openNativeFilePicker:sha256:f7bf483d63fe110a0226a778d1ef2d2bed05705446ab0c3ca509b019e68acddb",
          "kind": "host-effect",
          "capabilityId": "host.file-picker",
          "operation": "open-native"
        }
      ],
      "hostCapabilities": [
        {
          "channelId": "host-channel:openNativeFilePicker:sha256:7235aea9f5ede7d18f02165dad3746b53dbf622dbf1485e7a629ccf3b5a326a3",
          "capabilityId": "host.file-picker",
          "operation": "open-native"
        }
      ],
      "requiredHostCapabilities": [
        "host.file-picker"
      ],
      "missingConsumerPolicy": "block-host"
    },
    {
      "action": "payment",
      "runtimeAliases": [],
      "reads": [
        {
          "channelId": "parameter-channel:payment:$",
          "path": "$",
          "required": false,
          "role": "payload"
        },
        {
          "channelId": "parameter-channel:payment:resultTarget",
          "path": "resultTarget",
          "required": false,
          "role": "target"
        }
      ],
      "resultChannels": [
        {
          "channelId": "result-channel:payment:sha256:146242be8facc0968560b31a8cb2e32cec578853dbbedd0d6f28c951cc539e53",
          "kind": "host-effect",
          "capabilityId": "host.payment",
          "operation": "invoke"
        },
        {
          "channelId": "result-channel:payment:sha256:10f9620df5af8d2f3fb1dc75af1204b39072fc76abb2992529b0811d4e951a01",
          "kind": "state-target",
          "targetParam": "resultTarget",
          "defaultTarget": "_results.payment"
        }
      ],
      "hostCapabilities": [
        {
          "channelId": "host-channel:payment:sha256:f84a27b7316f60ca17c264ba3a86a84fff10740234a6f177c2d7a546f27c288b",
          "capabilityId": "host.payment",
          "operation": "invoke"
        }
      ],
      "requiredHostCapabilities": [
        "host.payment"
      ],
      "missingConsumerPolicy": "block-host"
    },
    {
      "action": "pickFiles",
      "runtimeAliases": [],
      "reads": [
        {
          "channelId": "parameter-channel:pickFiles:accept",
          "path": "accept",
          "required": false,
          "role": "input"
        },
        {
          "channelId": "parameter-channel:pickFiles:multiple",
          "path": "multiple",
          "required": false,
          "role": "guard"
        },
        {
          "aliases": [
            "resultTarget"
          ],
          "channelId": "parameter-channel:pickFiles:resultPath",
          "path": "resultPath",
          "required": false,
          "role": "target"
        }
      ],
      "resultChannels": [
        {
          "channelId": "result-channel:pickFiles:sha256:b8fe01ffcecd3d70286ad8ea44399aff0f5516726281525a118cf0ea230cd7f2",
          "kind": "host-effect",
          "capabilityId": "host.file-picker",
          "operation": "pick"
        },
        {
          "channelId": "result-channel:pickFiles:sha256:d439926e83b56b1185de39e807c9e939b9adf010edef29a6e90f78bc8435d80e",
          "kind": "state-target",
          "targetParam": "resultPath",
          "defaultTarget": "_results.pickFiles"
        }
      ],
      "hostCapabilities": [
        {
          "channelId": "host-channel:pickFiles:sha256:25f78897f9cfad0b5c842a2db4d679ef7339e79fa9251b46badeeb6d3fb06b72",
          "capabilityId": "host.file-picker",
          "operation": "pick"
        }
      ],
      "requiredHostCapabilities": [
        "host.file-picker"
      ],
      "missingConsumerPolicy": "block-host"
    },
    {
      "action": "printAction",
      "runtimeAliases": [],
      "reads": [],
      "resultChannels": [
        {
          "channelId": "result-channel:printAction:sha256:28416bec959d2bbb0521a7abf7184e377b2f4377366f3e41e39b0fd0a4e0b893",
          "kind": "host-effect",
          "capabilityId": "host.print",
          "operation": "print"
        }
      ],
      "hostCapabilities": [
        {
          "channelId": "host-channel:printAction:sha256:72adbb8f79e2da4cc3dbf0799bc359afd63728af1997a21ffa869731d937db20",
          "capabilityId": "host.print",
          "operation": "print"
        }
      ],
      "requiredHostCapabilities": [
        "host.print"
      ],
      "missingConsumerPolicy": "block-host"
    },
    {
      "action": "queueAction",
      "runtimeAliases": [],
      "reads": [
        {
          "channelId": "parameter-channel:queueAction:action",
          "path": "action",
          "required": true,
          "role": "selector"
        },
        {
          "channelId": "parameter-channel:queueAction:params",
          "path": "params",
          "required": false,
          "role": "payload"
        },
        {
          "channelId": "parameter-channel:queueAction:priority",
          "path": "priority",
          "required": false,
          "role": "input"
        },
        {
          "aliases": [
            "queueId"
          ],
          "channelId": "parameter-channel:queueAction:queue",
          "path": "queue",
          "required": false,
          "role": "selector"
        }
      ],
      "resultChannels": [],
      "hostCapabilities": [],
      "requiredHostCapabilities": [],
      "missingConsumerPolicy": "reject-before-side-effects"
    },
    {
      "action": "removeWhere",
      "runtimeAliases": [],
      "reads": [
        {
          "channelId": "parameter-channel:removeWhere:$",
          "path": "$",
          "required": false,
          "role": "payload"
        },
        {
          "channelId": "parameter-channel:removeWhere:target",
          "path": "target",
          "required": true,
          "role": "target"
        }
      ],
      "resultChannels": [
        {
          "channelId": "result-channel:removeWhere:sha256:5e680edc286f76bc1908e751533aa390759ed7860011a389f683935f75cfda7b",
          "kind": "state-target",
          "targetParam": "target"
        }
      ],
      "hostCapabilities": [],
      "requiredHostCapabilities": [],
      "missingConsumerPolicy": "reject-before-side-effects"
    },
    {
      "action": "restApi",
      "runtimeAliases": [
        "restful_data_action"
      ],
      "reads": [
        {
          "channelId": "parameter-channel:restApi:body",
          "path": "body",
          "required": false,
          "role": "payload"
        },
        {
          "channelId": "parameter-channel:restApi:credentials",
          "path": "credentials",
          "required": false,
          "role": "input"
        },
        {
          "channelId": "parameter-channel:restApi:headers",
          "path": "headers",
          "required": false,
          "role": "payload"
        },
        {
          "channelId": "parameter-channel:restApi:method",
          "path": "method",
          "required": false,
          "role": "selector"
        },
        {
          "aliases": [
            "responseKey",
            "resultKey",
            "target"
          ],
          "channelId": "parameter-channel:restApi:resultTarget",
          "path": "resultTarget",
          "required": false,
          "role": "target"
        },
        {
          "channelId": "parameter-channel:restApi:retryPolicy",
          "path": "retryPolicy",
          "required": false,
          "role": "payload"
        },
        {
          "channelId": "parameter-channel:restApi:throwOnHttpError",
          "path": "throwOnHttpError",
          "required": false,
          "role": "guard"
        },
        {
          "channelId": "parameter-channel:restApi:timeout",
          "path": "timeout",
          "required": false,
          "role": "input"
        },
        {
          "aliases": [
            "endpoint"
          ],
          "channelId": "parameter-channel:restApi:url",
          "path": "url",
          "required": true,
          "role": "input"
        }
      ],
      "resultChannels": [
        {
          "channelId": "result-channel:restApi:sha256:a1d9f94e51e4ea640bfc13d79d8c0d2222d5597a85c3bec6e4d2d9c5591ba7c4",
          "kind": "state-target",
          "targetParam": "resultTarget",
          "envelope": {
            "kind": "object",
            "properties": {
              "count": {
                "kind": "unknown"
              },
              "data": {
                "kind": "unknown"
              },
              "status": {
                "kind": "scalar",
                "type": "number"
              }
            },
            "required": [
              "data",
              "status"
            ]
          }
        }
      ],
      "hostCapabilities": [],
      "requiredHostCapabilities": [
        "host.fetch"
      ],
      "missingConsumerPolicy": "block-host"
    },
    {
      "action": "retryAction",
      "runtimeAliases": [],
      "reads": [
        {
          "channelId": "parameter-channel:retryAction:action",
          "path": "action",
          "required": true,
          "role": "selector"
        },
        {
          "aliases": [
            "baseDelay"
          ],
          "channelId": "parameter-channel:retryAction:delay",
          "path": "delay",
          "required": false,
          "role": "input"
        },
        {
          "channelId": "parameter-channel:retryAction:maxRetries",
          "path": "maxRetries",
          "required": false,
          "role": "guard"
        },
        {
          "channelId": "parameter-channel:retryAction:params",
          "path": "params",
          "required": false,
          "role": "payload"
        }
      ],
      "resultChannels": [],
      "hostCapabilities": [],
      "requiredHostCapabilities": [],
      "missingConsumerPolicy": "reject-before-side-effects"
    },
    {
      "action": "runMotion",
      "runtimeAliases": [],
      "reads": [
        {
          "channelId": "parameter-channel:runMotion:$",
          "path": "$",
          "required": false,
          "role": "payload"
        },
        {
          "channelId": "parameter-channel:runMotion:preset",
          "path": "preset",
          "required": true,
          "role": "selector"
        },
        {
          "channelId": "parameter-channel:runMotion:target",
          "path": "target",
          "required": true,
          "role": "input"
        }
      ],
      "resultChannels": [
        {
          "channelId": "result-channel:runMotion:sha256:cd94e04f86bc635f2194e48e15ffb2cb46af58c246601be011bb1701c502d69e",
          "kind": "host-effect",
          "capabilityId": "host.motion",
          "operation": "run"
        },
        {
          "channelId": "result-channel:runMotion:sha256:1182f31e9f03c5704bab18950e9381188a2a4411c1380c47c4fce875f9383d02",
          "kind": "return-capture",
          "capture": "step-name"
        }
      ],
      "hostCapabilities": [
        {
          "channelId": "host-channel:runMotion:sha256:f232724b7f8471e90257b07dc9fda7bfd0e916fd7e33cbad7204007a48907537",
          "capabilityId": "host.motion",
          "operation": "run"
        }
      ],
      "requiredHostCapabilities": [
        "host.motion"
      ],
      "missingConsumerPolicy": "block-host"
    },
    {
      "action": "scrollToElement",
      "runtimeAliases": [],
      "reads": [
        {
          "channelId": "parameter-channel:scrollToElement:behavior",
          "path": "behavior",
          "required": false,
          "role": "selector"
        },
        {
          "channelId": "parameter-channel:scrollToElement:smooth",
          "path": "smooth",
          "required": false,
          "role": "guard"
        },
        {
          "aliases": [
            "sectionId"
          ],
          "channelId": "parameter-channel:scrollToElement:target",
          "path": "target",
          "required": true,
          "role": "input"
        }
      ],
      "resultChannels": [
        {
          "channelId": "result-channel:scrollToElement:sha256:7bf782b55d2d93b699782252c6d7b058986a428d5ada06d0f2cfbda0a5e05c7d",
          "kind": "host-effect",
          "capabilityId": "host.scroll",
          "operation": "element"
        }
      ],
      "hostCapabilities": [
        {
          "channelId": "host-channel:scrollToElement:sha256:653a924a6455fab143804ed59f14c2381bc9293041e889d14c114170339f5991",
          "capabilityId": "host.scroll",
          "operation": "element"
        }
      ],
      "requiredHostCapabilities": [
        "host.scroll"
      ],
      "missingConsumerPolicy": "block-host"
    },
    {
      "action": "scrollToPosition",
      "runtimeAliases": [],
      "reads": [
        {
          "channelId": "parameter-channel:scrollToPosition:behavior",
          "path": "behavior",
          "required": false,
          "role": "selector"
        },
        {
          "channelId": "parameter-channel:scrollToPosition:smooth",
          "path": "smooth",
          "required": false,
          "role": "guard"
        },
        {
          "channelId": "parameter-channel:scrollToPosition:y",
          "path": "y",
          "required": false,
          "role": "input"
        }
      ],
      "resultChannels": [
        {
          "channelId": "result-channel:scrollToPosition:sha256:4fcad99b04f240deb57bdde2f5797a6b6d2d29af41d117ce6541f8aefdd4b8d2",
          "kind": "host-effect",
          "capabilityId": "host.scroll",
          "operation": "position"
        }
      ],
      "hostCapabilities": [
        {
          "channelId": "host-channel:scrollToPosition:sha256:2cfc37b4eca4a7413fb2ec2827a875867d904a3c77244e27b62547450c9bd436",
          "capabilityId": "host.scroll",
          "operation": "position"
        }
      ],
      "requiredHostCapabilities": [
        "host.scroll"
      ],
      "missingConsumerPolicy": "block-host"
    },
    {
      "action": "setState",
      "runtimeAliases": [],
      "reads": [
        {
          "channelId": "parameter-channel:setState:match",
          "path": "match",
          "required": false,
          "role": "guard"
        },
        {
          "channelId": "parameter-channel:setState:onMatch",
          "path": "onMatch",
          "required": false,
          "role": "payload"
        },
        {
          "channelId": "parameter-channel:setState:onNew",
          "path": "onNew",
          "required": false,
          "role": "payload"
        },
        {
          "channelId": "parameter-channel:setState:operation",
          "path": "operation",
          "required": false,
          "role": "selector"
        },
        {
          "channelId": "parameter-channel:setState:predicate",
          "path": "predicate",
          "required": false,
          "role": "guard"
        },
        {
          "channelId": "parameter-channel:setState:target",
          "path": "target",
          "required": true,
          "role": "target"
        },
        {
          "channelId": "parameter-channel:setState:update",
          "path": "update",
          "required": false,
          "role": "payload"
        },
        {
          "channelId": "parameter-channel:setState:value",
          "path": "value",
          "required": false,
          "role": "payload"
        }
      ],
      "resultChannels": [
        {
          "channelId": "result-channel:setState:sha256:5e680edc286f76bc1908e751533aa390759ed7860011a389f683935f75cfda7b",
          "kind": "state-target",
          "targetParam": "target"
        }
      ],
      "hostCapabilities": [],
      "requiredHostCapabilities": [],
      "missingConsumerPolicy": "reject-before-side-effects"
    },
    {
      "action": "setTableCell",
      "runtimeAliases": [],
      "reads": [
        {
          "channelId": "parameter-channel:setTableCell:field",
          "path": "field",
          "required": true,
          "role": "selector"
        },
        {
          "channelId": "parameter-channel:setTableCell:rowIndex",
          "path": "rowIndex",
          "required": true,
          "role": "selector"
        },
        {
          "channelId": "parameter-channel:setTableCell:target",
          "path": "target",
          "required": true,
          "role": "target"
        },
        {
          "channelId": "parameter-channel:setTableCell:value",
          "path": "value",
          "required": false,
          "role": "payload"
        }
      ],
      "resultChannels": [
        {
          "channelId": "result-channel:setTableCell:sha256:5e680edc286f76bc1908e751533aa390759ed7860011a389f683935f75cfda7b",
          "kind": "state-target",
          "targetParam": "target"
        }
      ],
      "hostCapabilities": [],
      "requiredHostCapabilities": [],
      "missingConsumerPolicy": "reject-before-side-effects"
    },
    {
      "action": "setTheme",
      "runtimeAliases": [],
      "reads": [
        {
          "channelId": "parameter-channel:setTheme:theme",
          "path": "theme",
          "required": true,
          "role": "selector"
        }
      ],
      "resultChannels": [
        {
          "channelId": "result-channel:setTheme:sha256:45ca71b844c98183df37749ccadc54c290e8c03417b893669d9cfcfce573a60f",
          "kind": "host-effect",
          "capabilityId": "host.theme",
          "operation": "set"
        }
      ],
      "hostCapabilities": [
        {
          "channelId": "host-channel:setTheme:sha256:55d61ad734cff2f94fb6ff009cb49474716b70320ec0a2a2111ebbb8d88b01eb",
          "capabilityId": "host.theme",
          "operation": "set"
        }
      ],
      "requiredHostCapabilities": [
        "host.theme"
      ],
      "missingConsumerPolicy": "block-host"
    },
    {
      "action": "setVariable",
      "runtimeAliases": [],
      "reads": [
        {
          "aliases": [
            "target"
          ],
          "channelId": "parameter-channel:setVariable:name",
          "path": "name",
          "required": true,
          "role": "target"
        },
        {
          "channelId": "parameter-channel:setVariable:scope",
          "path": "scope",
          "required": false,
          "role": "selector"
        },
        {
          "channelId": "parameter-channel:setVariable:value",
          "path": "value",
          "required": false,
          "role": "payload"
        }
      ],
      "resultChannels": [
        {
          "channelId": "result-channel:setVariable:sha256:ce7f20898e70d2c6f3eecd794971a4ba92bacd964350aa9a2a9221240fbf8bec",
          "kind": "state-target",
          "targetParam": "name"
        }
      ],
      "hostCapabilities": [],
      "requiredHostCapabilities": [],
      "missingConsumerPolicy": "reject-before-side-effects"
    },
    {
      "action": "shareAction",
      "runtimeAliases": [],
      "reads": [
        {
          "channelId": "parameter-channel:shareAction:files",
          "path": "files",
          "required": false,
          "role": "payload"
        },
        {
          "channelId": "parameter-channel:shareAction:text",
          "path": "text",
          "required": false,
          "role": "payload"
        },
        {
          "channelId": "parameter-channel:shareAction:title",
          "path": "title",
          "required": false,
          "role": "input"
        },
        {
          "channelId": "parameter-channel:shareAction:url",
          "path": "url",
          "required": false,
          "role": "input"
        }
      ],
      "resultChannels": [
        {
          "channelId": "result-channel:shareAction:sha256:9826c80e8475d4cc220f15328ef44142ba4702acdb84544851e02a758b073153",
          "kind": "host-effect",
          "capabilityId": "host.share",
          "operation": "share"
        }
      ],
      "hostCapabilities": [
        {
          "channelId": "host-channel:shareAction:sha256:e4e33a9593312ac2d61011813565a62934e04335a45d5f20c068ac66bd73f86c",
          "capabilityId": "host.share",
          "operation": "share"
        }
      ],
      "requiredHostCapabilities": [
        "host.share"
      ],
      "missingConsumerPolicy": "block-host"
    },
    {
      "action": "showLoading",
      "runtimeAliases": [],
      "reads": [
        {
          "channelId": "parameter-channel:showLoading:message",
          "path": "message",
          "required": false,
          "role": "input"
        },
        {
          "channelId": "parameter-channel:showLoading:overlay",
          "path": "overlay",
          "required": false,
          "role": "guard"
        },
        {
          "aliases": [
            "value"
          ],
          "channelId": "parameter-channel:showLoading:show",
          "path": "show",
          "required": false,
          "role": "guard"
        }
      ],
      "resultChannels": [
        {
          "channelId": "result-channel:showLoading:sha256:34bb04a5d3fa18ca8ab9d380a57775491db7639e7b93f56662e551ce0f9a0085",
          "kind": "host-effect",
          "capabilityId": "host.presentation",
          "operation": "loading"
        }
      ],
      "hostCapabilities": [
        {
          "channelId": "host-channel:showLoading:sha256:2028efe6e8c14247fc68a68291324cfde0c901a643828e6cf82dfc26ed957cf2",
          "capabilityId": "host.presentation",
          "operation": "loading"
        }
      ],
      "requiredHostCapabilities": [
        "host.presentation"
      ],
      "missingConsumerPolicy": "block-host"
    },
    {
      "action": "showPopup",
      "runtimeAliases": [],
      "reads": [
        {
          "channelId": "parameter-channel:showPopup:actions",
          "path": "actions",
          "required": false,
          "role": "payload"
        },
        {
          "channelId": "parameter-channel:showPopup:message",
          "path": "message",
          "required": false,
          "role": "input"
        },
        {
          "channelId": "parameter-channel:showPopup:title",
          "path": "title",
          "required": false,
          "role": "input"
        },
        {
          "channelId": "parameter-channel:showPopup:type",
          "path": "type",
          "required": false,
          "role": "selector"
        }
      ],
      "resultChannels": [
        {
          "channelId": "result-channel:showPopup:sha256:2c98f64ee204e8485463813a8b7c50621f1dff29e6e426c3d2aa2755431b9688",
          "kind": "host-effect",
          "capabilityId": "host.presentation",
          "operation": "popup"
        }
      ],
      "hostCapabilities": [
        {
          "channelId": "host-channel:showPopup:sha256:90bdd027fc20a2bdeb8d74e288d8169675f93cc2169dccafa28b7f8bc26eb4af",
          "capabilityId": "host.presentation",
          "operation": "popup"
        }
      ],
      "requiredHostCapabilities": [
        "host.presentation"
      ],
      "missingConsumerPolicy": "block-host"
    },
    {
      "action": "showToast",
      "runtimeAliases": [],
      "reads": [
        {
          "channelId": "parameter-channel:showToast:description",
          "path": "description",
          "required": false,
          "role": "input"
        },
        {
          "channelId": "parameter-channel:showToast:durationMs",
          "path": "durationMs",
          "required": false,
          "role": "input"
        },
        {
          "channelId": "parameter-channel:showToast:message",
          "path": "message",
          "required": false,
          "role": "input"
        },
        {
          "channelId": "parameter-channel:showToast:title",
          "path": "title",
          "required": false,
          "role": "input"
        },
        {
          "channelId": "parameter-channel:showToast:variant",
          "path": "variant",
          "required": false,
          "role": "selector"
        }
      ],
      "resultChannels": [
        {
          "channelId": "result-channel:showToast:sha256:ae67b9268486bb652609dcdcfda61e91dbe28a90f0c7e991943113fc545cd557",
          "kind": "host-effect",
          "capabilityId": "host.presentation",
          "operation": "toast"
        }
      ],
      "hostCapabilities": [
        {
          "channelId": "host-channel:showToast:sha256:564712a3621664ec10b17ae92d9c4a990ecc67bfb0ff1f9a9c039e9a518186da",
          "capabilityId": "host.presentation",
          "operation": "toast"
        }
      ],
      "requiredHostCapabilities": [
        "host.presentation"
      ],
      "missingConsumerPolicy": "block-host"
    },
    {
      "action": "sortByField",
      "runtimeAliases": [],
      "reads": [
        {
          "channelId": "parameter-channel:sortByField:direction",
          "path": "direction",
          "required": false,
          "role": "selector"
        },
        {
          "channelId": "parameter-channel:sortByField:field",
          "path": "field",
          "required": true,
          "role": "selector"
        },
        {
          "channelId": "parameter-channel:sortByField:source",
          "path": "source",
          "required": true,
          "role": "input"
        },
        {
          "channelId": "parameter-channel:sortByField:target",
          "path": "target",
          "required": true,
          "role": "target"
        }
      ],
      "resultChannels": [
        {
          "channelId": "result-channel:sortByField:sha256:5e680edc286f76bc1908e751533aa390759ed7860011a389f683935f75cfda7b",
          "kind": "state-target",
          "targetParam": "target"
        }
      ],
      "hostCapabilities": [],
      "requiredHostCapabilities": [],
      "missingConsumerPolicy": "reject-before-side-effects"
    },
    {
      "action": "stopFlow",
      "runtimeAliases": [],
      "reads": [
        {
          "channelId": "parameter-channel:stopFlow:reason",
          "path": "reason",
          "required": false,
          "role": "input"
        }
      ],
      "resultChannels": [],
      "hostCapabilities": [],
      "requiredHostCapabilities": [],
      "missingConsumerPolicy": "reject-before-side-effects"
    },
    {
      "action": "storage",
      "runtimeAliases": [],
      "reads": [
        {
          "channelId": "parameter-channel:storage:key",
          "path": "key",
          "required": false,
          "role": "input"
        },
        {
          "channelId": "parameter-channel:storage:operation",
          "path": "operation",
          "required": false,
          "role": "selector"
        },
        {
          "channelId": "parameter-channel:storage:resultPath",
          "path": "resultPath",
          "required": false,
          "role": "target"
        },
        {
          "channelId": "parameter-channel:storage:secure",
          "path": "secure",
          "required": false,
          "role": "guard"
        },
        {
          "channelId": "parameter-channel:storage:value",
          "path": "value",
          "required": false,
          "role": "payload"
        }
      ],
      "resultChannels": [
        {
          "channelId": "result-channel:storage:sha256:35cc4d65cc9ac5a00334e9a2638cf504c8ee5edd6b89b207b836f552281cf3ac",
          "kind": "host-effect",
          "when": {
            "param": "operation",
            "equals": [
              "remove"
            ]
          },
          "capabilityId": "host.storage",
          "operation": "remove"
        },
        {
          "channelId": "result-channel:storage:sha256:645a166a7da94edb1c4a288065710bf291213876e6b79a9769cc0aaf579bc277",
          "kind": "host-effect",
          "when": {
            "param": "operation",
            "equals": [
              "get"
            ]
          },
          "capabilityId": "host.storage",
          "operation": "get"
        },
        {
          "channelId": "result-channel:storage:sha256:8eb0bf143b471b05b24104f30138514bcc65604abc7bccc7cc5bd30c8791379d",
          "kind": "host-effect",
          "when": {
            "param": "operation",
            "equals": [
              "set"
            ]
          },
          "capabilityId": "host.storage",
          "operation": "set"
        },
        {
          "channelId": "result-channel:storage:sha256:ed56cd0b6b5bf3580701626f1586cffb743dc71de1c639d7d52ec7154161fdd9",
          "kind": "host-effect",
          "when": {
            "param": "operation",
            "equals": [
              "clear"
            ]
          },
          "capabilityId": "host.storage",
          "operation": "clear"
        },
        {
          "channelId": "result-channel:storage:sha256:ba5d8bd1aeb6348f627a7826a4425d32aca37a6b70edc01a8e9a9ebd9b19b9a3",
          "kind": "state-target",
          "when": {
            "param": "operation",
            "equals": [
              "get"
            ]
          },
          "targetParam": "resultPath"
        }
      ],
      "hostCapabilities": [
        {
          "channelId": "host-channel:storage:sha256:19c93c2a9d6e8fa31aee700b6d403fc5432ef0b121b90d1927512f9691c49f93",
          "capabilityId": "host.storage",
          "operation": "set",
          "when": {
            "param": "operation",
            "equals": [
              "set"
            ]
          }
        },
        {
          "channelId": "host-channel:storage:sha256:4a45020839a6f687aaa4152129641f4e547ffbf192df0173ae7d9953d8638197",
          "capabilityId": "host.storage",
          "operation": "get",
          "when": {
            "param": "operation",
            "equals": [
              "get"
            ]
          }
        },
        {
          "channelId": "host-channel:storage:sha256:4cf233dffdbdafddbb0a8da3674d62f0eeaf9e8a3c1b166e6333bdc5f42692b9",
          "capabilityId": "host.storage",
          "operation": "remove",
          "when": {
            "param": "operation",
            "equals": [
              "remove"
            ]
          }
        },
        {
          "channelId": "host-channel:storage:sha256:cd3a61f353f8e39be39dfa39a8315b24968003b53f2ee28d7c5a6206c6081047",
          "capabilityId": "host.storage",
          "operation": "clear",
          "when": {
            "param": "operation",
            "equals": [
              "clear"
            ]
          }
        }
      ],
      "requiredHostCapabilities": [
        "host.storage"
      ],
      "missingConsumerPolicy": "block-host"
    },
    {
      "action": "supabaseAuth",
      "runtimeAliases": [],
      "reads": [
        {
          "channelId": "parameter-channel:supabaseAuth:code",
          "path": "code",
          "required": false,
          "role": "input"
        },
        {
          "channelId": "parameter-channel:supabaseAuth:email",
          "path": "email",
          "required": false,
          "role": "input"
        },
        {
          "channelId": "parameter-channel:supabaseAuth:factorId",
          "path": "factorId",
          "required": false,
          "role": "input"
        },
        {
          "channelId": "parameter-channel:supabaseAuth:friendlyName",
          "path": "friendlyName",
          "required": false,
          "role": "input"
        },
        {
          "channelId": "parameter-channel:supabaseAuth:metadata",
          "path": "metadata",
          "required": false,
          "role": "payload"
        },
        {
          "channelId": "parameter-channel:supabaseAuth:method",
          "path": "method",
          "required": false,
          "role": "selector"
        },
        {
          "channelId": "parameter-channel:supabaseAuth:password",
          "path": "password",
          "required": false,
          "role": "input"
        },
        {
          "channelId": "parameter-channel:supabaseAuth:provider",
          "path": "provider",
          "required": false,
          "role": "input"
        },
        {
          "channelId": "parameter-channel:supabaseAuth:redirectTo",
          "path": "redirectTo",
          "required": false,
          "role": "input"
        },
        {
          "channelId": "parameter-channel:supabaseAuth:resultTarget",
          "path": "resultTarget",
          "required": false,
          "role": "target"
        },
        {
          "channelId": "parameter-channel:supabaseAuth:scopes",
          "path": "scopes",
          "required": false,
          "role": "input"
        },
        {
          "channelId": "parameter-channel:supabaseAuth:triggerFlow",
          "path": "triggerFlow",
          "required": false,
          "role": "input"
        }
      ],
      "resultChannels": [
        {
          "channelId": "result-channel:supabaseAuth:sha256:3273ed7786f42f8550b811d5879423d01aaebbcbc7348d350c8f8b69ced4c37e",
          "kind": "state-target",
          "targetParam": "resultTarget",
          "defaultTarget": "_results.auth"
        }
      ],
      "hostCapabilities": [],
      "requiredHostCapabilities": [
        "host.supabase"
      ],
      "missingConsumerPolicy": "block-host"
    },
    {
      "action": "supabaseQuery",
      "runtimeAliases": [],
      "reads": [
        {
          "channelId": "parameter-channel:supabaseQuery:columns",
          "path": "columns",
          "required": false,
          "role": "input"
        },
        {
          "channelId": "parameter-channel:supabaseQuery:count",
          "path": "count",
          "required": false,
          "role": "input"
        },
        {
          "channelId": "parameter-channel:supabaseQuery:data",
          "path": "data",
          "required": false,
          "role": "payload"
        },
        {
          "channelId": "parameter-channel:supabaseQuery:filters",
          "path": "filters",
          "required": false,
          "role": "payload"
        },
        {
          "channelId": "parameter-channel:supabaseQuery:method",
          "path": "method",
          "required": false,
          "role": "selector"
        },
        {
          "channelId": "parameter-channel:supabaseQuery:order",
          "path": "order",
          "required": false,
          "role": "payload"
        },
        {
          "channelId": "parameter-channel:supabaseQuery:range",
          "path": "range",
          "required": false,
          "role": "input"
        },
        {
          "channelId": "parameter-channel:supabaseQuery:resultTarget",
          "path": "resultTarget",
          "required": false,
          "role": "target"
        },
        {
          "channelId": "parameter-channel:supabaseQuery:single",
          "path": "single",
          "required": false,
          "role": "input"
        },
        {
          "channelId": "parameter-channel:supabaseQuery:table",
          "path": "table",
          "required": true,
          "role": "input"
        }
      ],
      "resultChannels": [
        {
          "channelId": "result-channel:supabaseQuery:sha256:b82b1d2582863398c57b2983c9c2944a04f25e109b772a63b0207c06a71e57a2",
          "kind": "state-target",
          "targetParam": "resultTarget",
          "defaultTargetFromParam": {
            "prefix": "_results.",
            "param": "table"
          }
        }
      ],
      "hostCapabilities": [],
      "requiredHostCapabilities": [
        "host.supabase"
      ],
      "missingConsumerPolicy": "block-host"
    },
    {
      "action": "supabaseRealtime",
      "runtimeAliases": [],
      "reads": [
        {
          "channelId": "parameter-channel:supabaseRealtime:action",
          "path": "action",
          "required": false,
          "role": "selector"
        },
        {
          "channelId": "parameter-channel:supabaseRealtime:channel",
          "path": "channel",
          "required": false,
          "role": "input"
        },
        {
          "channelId": "parameter-channel:supabaseRealtime:event",
          "path": "event",
          "required": false,
          "role": "input"
        },
        {
          "channelId": "parameter-channel:supabaseRealtime:eventType",
          "path": "eventType",
          "required": false,
          "role": "input"
        },
        {
          "channelId": "parameter-channel:supabaseRealtime:filter",
          "path": "filter",
          "required": false,
          "role": "input"
        },
        {
          "channelId": "parameter-channel:supabaseRealtime:payload",
          "path": "payload",
          "required": false,
          "role": "payload"
        },
        {
          "channelId": "parameter-channel:supabaseRealtime:resultTarget",
          "path": "resultTarget",
          "required": false,
          "role": "target"
        },
        {
          "channelId": "parameter-channel:supabaseRealtime:schema",
          "path": "schema",
          "required": false,
          "role": "input"
        },
        {
          "channelId": "parameter-channel:supabaseRealtime:state",
          "path": "state",
          "required": false,
          "role": "payload"
        },
        {
          "channelId": "parameter-channel:supabaseRealtime:table",
          "path": "table",
          "required": false,
          "role": "input"
        },
        {
          "channelId": "parameter-channel:supabaseRealtime:triggerFlow",
          "path": "triggerFlow",
          "required": false,
          "role": "input"
        }
      ],
      "resultChannels": [
        {
          "channelId": "result-channel:supabaseRealtime:sha256:8e13e9ae245fb6ac5ac6b9ade14c409bb8b4ae1ec36d1f0db2375ab2cefee188",
          "kind": "state-target",
          "targetParam": "resultTarget",
          "defaultTarget": "_results.realtime"
        }
      ],
      "hostCapabilities": [],
      "requiredHostCapabilities": [
        "host.supabase"
      ],
      "missingConsumerPolicy": "block-host"
    },
    {
      "action": "supabaseRpc",
      "runtimeAliases": [],
      "reads": [
        {
          "channelId": "parameter-channel:supabaseRpc:args",
          "path": "args",
          "required": false,
          "role": "payload"
        },
        {
          "channelId": "parameter-channel:supabaseRpc:functionName",
          "path": "functionName",
          "required": false,
          "role": "input"
        },
        {
          "channelId": "parameter-channel:supabaseRpc:resultTarget",
          "path": "resultTarget",
          "required": false,
          "role": "target"
        },
        {
          "channelId": "parameter-channel:supabaseRpc:retryCount",
          "path": "retryCount",
          "required": false,
          "role": "input"
        }
      ],
      "resultChannels": [
        {
          "channelId": "result-channel:supabaseRpc:sha256:a1b957966327040ab323b81c13f467b2c56f5714f2ee779c90dd54b577447c89",
          "kind": "state-target",
          "targetParam": "resultTarget",
          "defaultTarget": "_results.rpc"
        }
      ],
      "hostCapabilities": [],
      "requiredHostCapabilities": [
        "host.supabase"
      ],
      "missingConsumerPolicy": "block-host"
    },
    {
      "action": "supabaseStorage",
      "runtimeAliases": [],
      "reads": [
        {
          "channelId": "parameter-channel:supabaseStorage:bucket",
          "path": "bucket",
          "required": false,
          "role": "input"
        },
        {
          "channelId": "parameter-channel:supabaseStorage:contentType",
          "path": "contentType",
          "required": false,
          "role": "input"
        },
        {
          "channelId": "parameter-channel:supabaseStorage:expiresIn",
          "path": "expiresIn",
          "required": false,
          "role": "input"
        },
        {
          "channelId": "parameter-channel:supabaseStorage:file",
          "path": "file",
          "required": false,
          "role": "payload"
        },
        {
          "channelId": "parameter-channel:supabaseStorage:method",
          "path": "method",
          "required": false,
          "role": "selector"
        },
        {
          "channelId": "parameter-channel:supabaseStorage:path",
          "path": "path",
          "required": false,
          "role": "input"
        },
        {
          "channelId": "parameter-channel:supabaseStorage:paths",
          "path": "paths",
          "required": false,
          "role": "input"
        },
        {
          "channelId": "parameter-channel:supabaseStorage:resultTarget",
          "path": "resultTarget",
          "required": false,
          "role": "target"
        },
        {
          "channelId": "parameter-channel:supabaseStorage:upsert",
          "path": "upsert",
          "required": false,
          "role": "input"
        }
      ],
      "resultChannels": [
        {
          "channelId": "result-channel:supabaseStorage:sha256:70d582ce232d147b5474c697f5b159a6822dfb5fdb1ee9840a07f2f929f5e7a1",
          "kind": "state-target",
          "targetParam": "resultTarget",
          "defaultTarget": "_results.storage"
        }
      ],
      "hostCapabilities": [],
      "requiredHostCapabilities": [
        "host.supabase"
      ],
      "missingConsumerPolicy": "block-host"
    },
    {
      "action": "throttleAction",
      "runtimeAliases": [],
      "reads": [
        {
          "channelId": "parameter-channel:throttleAction:action",
          "path": "action",
          "required": true,
          "role": "selector"
        },
        {
          "channelId": "parameter-channel:throttleAction:interval",
          "path": "interval",
          "required": false,
          "role": "input"
        },
        {
          "channelId": "parameter-channel:throttleAction:key",
          "path": "key",
          "required": false,
          "role": "selector"
        },
        {
          "channelId": "parameter-channel:throttleAction:params",
          "path": "params",
          "required": false,
          "role": "payload"
        }
      ],
      "resultChannels": [],
      "hostCapabilities": [],
      "requiredHostCapabilities": [],
      "missingConsumerPolicy": "reject-before-side-effects"
    },
    {
      "action": "transactionAction",
      "runtimeAliases": [],
      "reads": [
        {
          "aliases": [
            "steps"
          ],
          "channelId": "parameter-channel:transactionAction:actions",
          "path": "actions",
          "required": true,
          "role": "payload"
        },
        {
          "channelId": "parameter-channel:transactionAction:resultTarget",
          "path": "resultTarget",
          "required": false,
          "role": "target"
        },
        {
          "channelId": "parameter-channel:transactionAction:rollback",
          "path": "rollback",
          "required": false,
          "role": "payload"
        }
      ],
      "resultChannels": [
        {
          "channelId": "result-channel:transactionAction:sha256:c949fbb074f16f1acd95aa5c07c431f37e6ba80035d82eadc0ac20c4f21ea06d",
          "kind": "state-target",
          "targetParam": "resultTarget",
          "defaultTarget": "_results.transaction"
        }
      ],
      "hostCapabilities": [],
      "requiredHostCapabilities": [],
      "missingConsumerPolicy": "reject-before-side-effects"
    },
    {
      "action": "updateWhere",
      "runtimeAliases": [],
      "reads": [
        {
          "channelId": "parameter-channel:updateWhere:$",
          "path": "$",
          "required": false,
          "role": "payload"
        },
        {
          "channelId": "parameter-channel:updateWhere:target",
          "path": "target",
          "required": true,
          "role": "target"
        }
      ],
      "resultChannels": [
        {
          "channelId": "result-channel:updateWhere:sha256:5e680edc286f76bc1908e751533aa390759ed7860011a389f683935f75cfda7b",
          "kind": "state-target",
          "targetParam": "target"
        }
      ],
      "hostCapabilities": [],
      "requiredHostCapabilities": [],
      "missingConsumerPolicy": "reject-before-side-effects"
    },
    {
      "action": "uploadFiles",
      "runtimeAliases": [],
      "reads": [
        {
          "channelId": "parameter-channel:uploadFiles:files",
          "path": "files",
          "required": false,
          "role": "payload"
        },
        {
          "aliases": [
            "target"
          ],
          "channelId": "parameter-channel:uploadFiles:resultTarget",
          "path": "resultTarget",
          "required": false,
          "role": "target"
        },
        {
          "aliases": [
            "datasourceId"
          ],
          "channelId": "parameter-channel:uploadFiles:source",
          "path": "source",
          "required": true,
          "role": "selector"
        }
      ],
      "resultChannels": [
        {
          "channelId": "result-channel:uploadFiles:sha256:4a393f959b4d793fd47d310f26bee380cd415cc1993b56f49caa3903a60cfa94",
          "kind": "host-effect",
          "capabilityId": "host.datasource",
          "operation": "upload"
        },
        {
          "channelId": "result-channel:uploadFiles:sha256:cfa477a83e214c8089a53ed6b0f1b8ef3c0729ade8233b071fd27086dcec6287",
          "kind": "state-target",
          "targetParam": "resultTarget"
        }
      ],
      "hostCapabilities": [
        {
          "channelId": "host-channel:uploadFiles:sha256:2cf59c32dd8e5f10f87b6c9b4af5f9abea01cb58cbfe96ddebd74f6008d2a280",
          "capabilityId": "host.datasource",
          "operation": "upload"
        }
      ],
      "requiredHostCapabilities": [
        "host.datasource"
      ],
      "missingConsumerPolicy": "block-host"
    },
    {
      "action": "upsertWhere",
      "runtimeAliases": [],
      "reads": [
        {
          "channelId": "parameter-channel:upsertWhere:$",
          "path": "$",
          "required": false,
          "role": "payload"
        },
        {
          "channelId": "parameter-channel:upsertWhere:target",
          "path": "target",
          "required": true,
          "role": "target"
        }
      ],
      "resultChannels": [
        {
          "channelId": "result-channel:upsertWhere:sha256:5e680edc286f76bc1908e751533aa390759ed7860011a389f683935f75cfda7b",
          "kind": "state-target",
          "targetParam": "target"
        }
      ],
      "hostCapabilities": [],
      "requiredHostCapabilities": [],
      "missingConsumerPolicy": "reject-before-side-effects"
    },
    {
      "action": "validate",
      "runtimeAliases": [],
      "reads": [
        {
          "channelId": "parameter-channel:validate:rules",
          "path": "rules",
          "required": false,
          "role": "payload"
        },
        {
          "channelId": "parameter-channel:validate:target",
          "path": "target",
          "required": true,
          "role": "input"
        }
      ],
      "resultChannels": [
        {
          "channelId": "result-channel:validate:sha256:1182f31e9f03c5704bab18950e9381188a2a4411c1380c47c4fce875f9383d02",
          "kind": "return-capture",
          "capture": "step-name"
        }
      ],
      "hostCapabilities": [],
      "requiredHostCapabilities": [],
      "missingConsumerPolicy": "reject-before-side-effects"
    },
    {
      "action": "wallet.create",
      "runtimeAliases": [],
      "reads": [
        {
          "channelId": "parameter-channel:wallet.create:$",
          "path": "$",
          "required": false,
          "role": "payload"
        },
        {
          "channelId": "parameter-channel:wallet.create:resultTarget",
          "path": "resultTarget",
          "required": false,
          "role": "target"
        }
      ],
      "resultChannels": [
        {
          "channelId": "result-channel:wallet.create:sha256:311f4912635f1cbd6dee5ed609a0373489e3b5b8f0e4c8c1967184240f81da1c",
          "kind": "state-target",
          "targetParam": "resultTarget",
          "defaultTarget": "_results.wallet.create"
        }
      ],
      "hostCapabilities": [],
      "requiredHostCapabilities": [
        "host.wallet-api"
      ],
      "missingConsumerPolicy": "block-host"
    },
    {
      "action": "wallet.estimateFee",
      "runtimeAliases": [],
      "reads": [
        {
          "channelId": "parameter-channel:wallet.estimateFee:$",
          "path": "$",
          "required": false,
          "role": "payload"
        },
        {
          "channelId": "parameter-channel:wallet.estimateFee:resultTarget",
          "path": "resultTarget",
          "required": false,
          "role": "target"
        }
      ],
      "resultChannels": [
        {
          "channelId": "result-channel:wallet.estimateFee:sha256:dadb667939bc821b6f75e59a1cb99f228fe3d2b1add00c2f1c6a8125ba0bfd26",
          "kind": "state-target",
          "targetParam": "resultTarget",
          "defaultTarget": "_results.wallet.fee"
        }
      ],
      "hostCapabilities": [],
      "requiredHostCapabilities": [
        "host.wallet-api"
      ],
      "missingConsumerPolicy": "block-host"
    },
    {
      "action": "wallet.getBalance",
      "runtimeAliases": [],
      "reads": [
        {
          "channelId": "parameter-channel:wallet.getBalance:resultTarget",
          "path": "resultTarget",
          "required": false,
          "role": "target"
        },
        {
          "channelId": "parameter-channel:wallet.getBalance:walletId",
          "path": "walletId",
          "required": true,
          "role": "input"
        }
      ],
      "resultChannels": [
        {
          "channelId": "result-channel:wallet.getBalance:sha256:3a2c0fba555b86ef8f90edb88b14d004afb52b381f9f84d29a9341a85f8ab79d",
          "kind": "state-target",
          "targetParam": "resultTarget",
          "defaultTarget": "_results.wallet.balance"
        }
      ],
      "hostCapabilities": [],
      "requiredHostCapabilities": [
        "host.wallet-api"
      ],
      "missingConsumerPolicy": "block-host"
    },
    {
      "action": "wallet.getTxHistory",
      "runtimeAliases": [],
      "reads": [
        {
          "channelId": "parameter-channel:wallet.getTxHistory:limit",
          "path": "limit",
          "required": false,
          "role": "input"
        },
        {
          "channelId": "parameter-channel:wallet.getTxHistory:network",
          "path": "network",
          "required": false,
          "role": "input"
        },
        {
          "channelId": "parameter-channel:wallet.getTxHistory:offset",
          "path": "offset",
          "required": false,
          "role": "input"
        },
        {
          "channelId": "parameter-channel:wallet.getTxHistory:resultTarget",
          "path": "resultTarget",
          "required": false,
          "role": "target"
        },
        {
          "channelId": "parameter-channel:wallet.getTxHistory:walletId",
          "path": "walletId",
          "required": true,
          "role": "input"
        }
      ],
      "resultChannels": [
        {
          "channelId": "result-channel:wallet.getTxHistory:sha256:3bab421696b9768b1f033ce98f17db65dc7e43944877b12ff3ee8317f41fe1a0",
          "kind": "state-target",
          "targetParam": "resultTarget",
          "defaultTarget": "_results.wallet.txHistory"
        }
      ],
      "hostCapabilities": [],
      "requiredHostCapabilities": [
        "host.wallet-api"
      ],
      "missingConsumerPolicy": "block-host"
    },
    {
      "action": "wallet.getTxStatus",
      "runtimeAliases": [],
      "reads": [
        {
          "channelId": "parameter-channel:wallet.getTxStatus:requestId",
          "path": "requestId",
          "required": true,
          "role": "input"
        },
        {
          "channelId": "parameter-channel:wallet.getTxStatus:resultTarget",
          "path": "resultTarget",
          "required": false,
          "role": "target"
        }
      ],
      "resultChannels": [
        {
          "channelId": "result-channel:wallet.getTxStatus:sha256:bfb9213880ef0cb78ef7cdc99e7ebb3fa41bc7b9d539c721322140cc3c8161fc",
          "kind": "state-target",
          "targetParam": "resultTarget",
          "defaultTarget": "_results.wallet.txStatus"
        }
      ],
      "hostCapabilities": [],
      "requiredHostCapabilities": [
        "host.wallet-api"
      ],
      "missingConsumerPolicy": "block-host"
    },
    {
      "action": "wallet.list",
      "runtimeAliases": [],
      "reads": [
        {
          "channelId": "parameter-channel:wallet.list:network",
          "path": "network",
          "required": false,
          "role": "input"
        },
        {
          "channelId": "parameter-channel:wallet.list:resultTarget",
          "path": "resultTarget",
          "required": false,
          "role": "target"
        }
      ],
      "resultChannels": [
        {
          "channelId": "result-channel:wallet.list:sha256:f6507cd3b9befce750f02a7b2b4f22d55ee0ef62d2d382ced46c8cae9accc5c2",
          "kind": "state-target",
          "targetParam": "resultTarget",
          "defaultTarget": "_results.wallet.list"
        }
      ],
      "hostCapabilities": [],
      "requiredHostCapabilities": [
        "host.wallet-api"
      ],
      "missingConsumerPolicy": "block-host"
    },
    {
      "action": "wallet.send",
      "runtimeAliases": [],
      "reads": [
        {
          "channelId": "parameter-channel:wallet.send:$",
          "path": "$",
          "required": false,
          "role": "payload"
        },
        {
          "channelId": "parameter-channel:wallet.send:resultTarget",
          "path": "resultTarget",
          "required": false,
          "role": "target"
        },
        {
          "channelId": "parameter-channel:wallet.send:walletId",
          "path": "walletId",
          "required": true,
          "role": "input"
        }
      ],
      "resultChannels": [
        {
          "channelId": "result-channel:wallet.send:sha256:c278001fe367b8e1ae9869112cfdb44328207d4c926431be6a9828f7c92c3231",
          "kind": "state-target",
          "targetParam": "resultTarget",
          "defaultTarget": "_results.wallet.send"
        }
      ],
      "hostCapabilities": [],
      "requiredHostCapabilities": [
        "host.wallet-api"
      ],
      "missingConsumerPolicy": "block-host"
    },
    {
      "action": "wallet.syncBalance",
      "runtimeAliases": [],
      "reads": [
        {
          "channelId": "parameter-channel:wallet.syncBalance:resultTarget",
          "path": "resultTarget",
          "required": false,
          "role": "target"
        },
        {
          "channelId": "parameter-channel:wallet.syncBalance:walletId",
          "path": "walletId",
          "required": true,
          "role": "input"
        }
      ],
      "resultChannels": [
        {
          "channelId": "result-channel:wallet.syncBalance:sha256:eccfce7ff25ef95d37c1c85b12d77f03b925187fa9f5fc367d2d5de817cd4f57",
          "kind": "state-target",
          "targetParam": "resultTarget",
          "defaultTarget": "_results.wallet.syncBalance"
        }
      ],
      "hostCapabilities": [],
      "requiredHostCapabilities": [
        "host.wallet-api"
      ],
      "missingConsumerPolicy": "block-host"
    },
    {
      "action": "web3",
      "runtimeAliases": [],
      "reads": [
        {
          "channelId": "parameter-channel:web3:$",
          "path": "$",
          "required": false,
          "role": "payload"
        },
        {
          "channelId": "parameter-channel:web3:resultTarget",
          "path": "resultTarget",
          "required": false,
          "role": "target"
        }
      ],
      "resultChannels": [
        {
          "channelId": "result-channel:web3:sha256:f883799a399eb8f5f28d58f9cfee4064d73b931ea5f3d546fa7586d7bd07dac1",
          "kind": "host-effect",
          "capabilityId": "host.web3",
          "operation": "invoke"
        },
        {
          "channelId": "result-channel:web3:sha256:6878d58a76dd710b5ccceef7b95676b74974fa05b42e85e1e75842272d265f1e",
          "kind": "state-target",
          "targetParam": "resultTarget",
          "defaultTarget": "_results.web3"
        }
      ],
      "hostCapabilities": [
        {
          "channelId": "host-channel:web3:sha256:6b84dca0827f54da95a5d521d5200bc996b358c05c3a9293667e8909ca9fbf00",
          "capabilityId": "host.web3",
          "operation": "invoke"
        }
      ],
      "requiredHostCapabilities": [
        "host.web3"
      ],
      "missingConsumerPolicy": "block-host"
    },
    {
      "action": "websocket",
      "runtimeAliases": [],
      "reads": [
        {
          "channelId": "parameter-channel:websocket:action",
          "path": "action",
          "required": false,
          "role": "selector"
        },
        {
          "channelId": "parameter-channel:websocket:connectionId",
          "path": "connectionId",
          "required": false,
          "role": "selector"
        },
        {
          "channelId": "parameter-channel:websocket:data",
          "path": "data",
          "required": false,
          "role": "payload"
        },
        {
          "channelId": "parameter-channel:websocket:resultTarget",
          "path": "resultTarget",
          "required": false,
          "role": "target"
        },
        {
          "channelId": "parameter-channel:websocket:url",
          "path": "url",
          "required": false,
          "role": "input"
        }
      ],
      "resultChannels": [
        {
          "channelId": "result-channel:websocket:sha256:e8b236769d68197e842f57093d4c75334bb4cbe5ccc82a4270f8291e94079282",
          "kind": "host-effect",
          "capabilityId": "host.websocket",
          "operation": "dispatch"
        },
        {
          "channelId": "result-channel:websocket:sha256:64ef9500c66ec5f80b1ff16fe6a0113a02900fefac75c3a7ef063413154c6f5e",
          "kind": "state-target",
          "targetParam": "resultTarget",
          "defaultTargetFromParam": {
            "prefix": "_results.ws.",
            "param": "connectionId",
            "fallback": "default"
          },
          "targetSuffixes": [
            "__ws",
            "connected",
            "lastMessage"
          ]
        }
      ],
      "hostCapabilities": [
        {
          "channelId": "host-channel:websocket:sha256:9e42b54be47e6f5dea504d06c16d4fb6846976988573f314ad3cde463d154bae",
          "capabilityId": "host.websocket",
          "operation": "dispatch"
        }
      ],
      "requiredHostCapabilities": [
        "host.websocket"
      ],
      "missingConsumerPolicy": "block-host"
    }
  ]
}
